export const EN_NAME = 'EN';

export const EN_TRANS = {
  // UPS Service Types
  '01' : 'UPS Next Day Air',
  '01S': 'UPS Next Day Air (Saturday)',
  '02' : 'UPS 2nd Day Air',
  '02S': 'UPS 2nd Day Air (Saturday)',
  '03' : 'UPS Ground',
  //'07' : 'UPS Standard',
  '07' : 'UPS Worldwide Express',
  '08' : 'UPS Worldwide Expedited',
  //'11' : 'UPS Worldwide Express',
  '11' : 'UPS Standard',
  '12' : 'UPS 3 Day Select',
  '13' : 'UPS Next Day Air Saver',
  '14' : 'UPS Next Day Air Early',
  '14S': 'UPS Next Day Air Early (Saturday)',
  '54' : 'UPS Worldwide Express Plus',
  '59' : 'UPS 2nd Day Air A.M.®',
  '65' : 'UPS Worldwide Saver',
  'M4' : 'UPS Mail Innovations',

  '22FOR2_INSTRUCTIONS' : 'Place stickers inside envelope and place Address label and Avery label on outside of envelope.',
  '22FOR2_PACKING_INSTRUCTIONS' : 'Please pack order without Packing List.',
  
  
  'UPS_01'     : 'UPS Next Day Air',
  'UPS_01S'    : 'UPS Next Day Air (Saturday)',
  'UPS_02'     : 'UPS 2nd Day Air',
  'UPS_02S'    : 'UPS 2nd Day Air (Saturday)',
  'UPS_03'     : 'UPS Ground',
  'UPS_07'     : 'UPS Worldwide Express',
  'UPS_08'     : 'UPS Worldwide Expedited',
  'UPS_11'     : 'UPS Standard',
  'UPS_12'     : 'UPS 3 Day Select',
  'UPS_13'     : 'UPS Next Day Air Saver',
  'UPS_14'     : 'UPS Next Day Air Early',
  'UPS_14S'    : 'UPS Next Day Air Early (Saturday)',
  'UPS_54'     : 'UPS Worldwide Express Plus',
  'UPS_59'     : 'UPS 2nd Day Air A.M.®',
  'UPS_65'     : 'UPS Worldwide Saver',
  'USPS_0_FCLE': 'UPS Mail Innovations',
  'USPS_0_FCL' : 'UPS Mail Innovations',
  'USPS_0_FCP' : 'UPS Mail Innovations',
  'USPS_0_FCPC': 'UPS Mail Innovations',
  'USPS_1'     : 'UPS Mail Innovations',
  'USPS_2'     : 'UPS Mail Innovations',
  'USPS_3'     : 'UPS Mail Innovations',
  'USPS_4'     : 'UPS Mail Innovations',
  'USPS_5'     : 'UPS Mail Innovations',
  'USPS_6'     : 'UPS Mail Innovations',
  'USPS_13'    : 'UPS Mail Innovations',
  'USPS_15'    : 'UPS Mail Innovations',
  'USPS_16'    : 'UPS Mail Innovations',
  'USPS_17'    : 'UPS Mail Innovations',
  'USPS_22'    : 'UPS Mail Innovations',
  'USPS_23'    : 'UPS Mail Innovations',
  'USPS_25'    : 'UPS Mail Innovations',
  'USPS_27'    : 'UPS Mail Innovations',
  'USPS_28'    : 'UPS Mail Innovations',
  'USPS_29'    : 'UPS Mail Innovations',
  'USPS_30'    : 'UPS Mail Innovations',
  'USPS_31'    : 'UPS Mail Innovations',
  'USPS_32'    : 'UPS Mail Innovations',
  'USPS_33'    : 'UPS Mail Innovations',
  'USPS_34'    : 'UPS Mail Innovations',
  'USPS_35'    : 'UPS Mail Innovations',
  'USPS_36'    : 'UPS Mail Innovations',
  'USPS_37'    : 'UPS Mail Innovations',
  'USPS_38'    : 'UPS Mail Innovations',
  'USPS_39'    : 'UPS Mail Innovations',
  'USPS_40'    : 'UPS Mail Innovations',
  'USPS_41'    : 'UPS Mail Innovations',
  'USPS_42'    : 'UPS Mail Innovations',
  'USPS_43'    : 'UPS Mail Innovations',
  'USPS_44'    : 'UPS Mail Innovations',
  'USPS_45'    : 'UPS Mail Innovations',
  'USPS_46'    : 'UPS Mail Innovations',
  'USPS_47'    : 'UPS Mail Innovations',
  'USPS_48'    : 'UPS Mail Innovations',
  'USPS_49'    : 'UPS Mail Innovations',
  'USPS_50'    : 'UPS Mail Innovations',
  'USPS_53'    : 'UPS Mail Innovations',
  'USPS_55'    : 'UPS Mail Innovations',
  'USPS_56'    : 'UPS Mail Innovations',
  'USPS_57'    : 'UPS Mail Innovations',
  'USPS_58'    : 'UPS Mail Innovations',
  'USPS_59'    : 'UPS Mail Innovations',
  'USPS_61'    : 'UPS Mail Innovations',
  'USPS_62'    : 'UPS Mail Innovations',
  'USPS_63'    : 'UPS Mail Innovations',
  'USPS_64'    : 'UPS Mail Innovations',
  'USPS_INT_1' : 'UPS Mail Innovations',
  'USPS_INT_2' : 'UPS Mail Innovations',
  'USPS_INT_4' : 'UPS Mail Innovations',
  'USPS_INT_5' : 'UPS Mail Innovations',
  'USPS_INT_6' : 'UPS Mail Innovations',
  'USPS_INT_7' : 'UPS Mail Innovations',
  'USPS_INT_8' : 'UPS Mail Innovations',
  'USPS_INT_9' : 'UPS Mail Innovations',
  'USPS_INT_10': 'UPS Mail Innovations',
  'USPS_INT_11': 'UPS Mail Innovations',
  'USPS_INT_12': 'UPS Mail Innovations',
  'USPS_INT_13': 'UPS Mail Innovations',
  'USPS_INT_14': 'UPS Mail Innovations',
  'USPS_INT_15': 'UPS Mail Innovations',
  'USPS_INT_16': 'UPS Mail Innovations',
  'USPS_INT_17': 'UPS Mail Innovations',
  'USPS_INT_18': 'UPS Mail Innovations',
  'USPS_INT_19': 'UPS Mail Innovations',
  'USPS_INT_20': 'UPS Mail Innovations',
  'USPS_INT_21': 'UPS Mail Innovations',
  'USPS_INT_22': 'UPS Mail Innovations',
  'USPS_INT_23': 'UPS Mail Innovations',
  'USPS_INT_24': 'UPS Mail Innovations',
  'USPS_INT_25': 'UPS Mail Innovations',
  'USPS_INT_26': 'UPS Mail Innovations',
  'USPS_INT_27': 'UPS Mail Innovations',
  // FedEx
  'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS': 'FedEx International Priority® Express',
  'INTERNATIONAL_FIRST'                 : 'FedEx International First®',
  'FEDEX_INTERNATIONAL_PRIORITY'        : 'FedEx International Priority®',
  'INTERNATIONAL_ECONOMY'               : 'FedEx International Economy®',
  'FEDEX_GROUND'                        : 'FedEx Ground',
  'FEDEX_CARGO_INTERNATIONAL_PREMIUM'   : 'FedEx International Premium®',
  'FIRST_OVERNIGHT'                     : 'FedEx First Overnight®',
  'FEDEX_FIRST_FREIGHT'                 : 'FedEx First Overnight® Freight',
  'FEDEX_1_DAY_FREIGHT'                 : 'FedEx 1Day® Freight  (Hawaii service is to and from the island of Oahu only)',
  'FEDEX_2_DAY_FREIGHT'                 : 'FedEx 2Day® Freight (Hawaii service is to and from the island of Oahu only)',
  'FEDEX_3_DAY_FREIGHT'                 : 'FedEx 3Day® Freight (Except Alaska and Hawaii)',
  'INTERNATIONAL_PRIORITY_FREIGHT'      : 'FedEx International Priority® Freight',
  'INTERNATIONAL_ECONOMY_FREIGHT'       : 'FedEx International Economy® Freight',
  'FEDEX_CARGO_AIRPORT_TO_AIRPORT'      : 'FedEx International Express Freight® and FedEx International Airport-to-AirportSM',
  'INTERNATIONAL_PRIORITY_DISTRIBUTION' : 'FedEx International Priority DirectDistribution®',
  'FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT': 'FedEx International Priority DirectDistribution® Freight',
  'INTL_GROUND_DISTRIBUTION'            : 'International Ground® Distribution (IGD)',
  'GROUND_HOME_DELIVERY'                : 'FedEx Home Delivery',
  'SMART_POST'                          : 'FedEx SmartPost',
  'PRIORITY_OVERNIGHT'                  : 'FedEx Priority Overnight®',
  'STANDARD_OVERNIGHT'                  : 'FedEx Standard Overnight',
  'FEDEX_2_DAY'                         : 'FedEx 2Day® (Except Intra-Hawaii)',
  'FEDEX_2_DAY_AM'                      : 'FedEx 2Day® AM (Hawaii outbound only)',
  'FEDEX_EXPRESS_SAVER'                 : 'FedEx Express Saver® (Except Alaska and Hawaii)',
  'SAME_DAY'                            : 'FedEx SameDay®',
  'SAME_DAY_CITY'                       : 'FedEx SameDay® City (Selected U.S. Metro Areas)',
  'FIRST_OVERNIGHT_SATURDAY'            : 'FedEx First Overnight® (Saturday)',
  'PRIORITY_OVERNIGHT_SATURDAY'         : 'FedEx Priority Overnight® (Saturday)',
  'STANDARD_OVERNIGHT_SATURDAY'         : 'FedEx Standard Overnight (Saturday)',
  'FEDEX_2_DAY_SATURDAY'                : 'FedEx 2Day® (Saturday)',
  'FEDEX_2_DAY_AM_SATURDAY'             : 'FedEx 2Day® AM (Saturday - Hawaii outbound only)',

  // FedEx Address Validation Response Code
  // 'STANDARDIZED.ADDRESS.NOTFOUND' : 'Address Not Found',
  'INVALID_SUITE_NUMBER' : 'Invalid or missing Apartment/Suite',
  'SUITE_NUMBER_REQUIRED' : 'Invalid or missing Apartment/Suite',
  'PARTIAL_STREET_MATCH' : 'A street address is required for delivery. The entered address is a street number range.',
  'MISSING_OR_AMBIGUOUS_DIRECTIONAL' : 'Invalid or missing address directional.',
  'INTERPOLATED_STREET_ADDRESS' : 'Unable to confirm exact street number for the entered street name. The address falls within a valid range for the street name.',
  'RRHC_CONVERSIO' : 'A street address is required for delivery. The address has been converted from a rural route.',

  // Product Materials
  'CARDSTOCK'         : 'Card Stock',
  'CLEARFILM'         : 'Clear Film',
  'WHITEFILM'         : 'White Film',
  'SILVERFILM'        : 'Silver Film',
  'KRAFTPAPER'        : 'Kraft Paper',
  'MATTEPAPER'        : 'Matte Paper',
  'WHITEMATTEPAPER'   : 'White Matte Paper',
  'ADHESIVENAMEBADGES': 'Adhesive Name Badges',
  'BUMPERSTICKERFILM' : 'Bumper Sticker Film',
  ACCESSORY : {
    CHECK_FOR_ORDER : 'Accessory Check for Order',
    OK            : 'Accessory OK',
    ADD           : 'Add Accessory',
    CHECK         : 'Accessory Check',
    CHECK_JOB     : 'Please check each job\'s accessory and ensure the accessory type and amount are correct',
    MISSING       : 'Missing Accessory',
    HOLD_PROMPT   : 'Select jobs with accessory issues and add a hold reason (required): ',
    NOT_OKAY_HOLD : 'Accessory Not OK / Hold ',
    SCAN_ERROR_TITLE        : 'Accessory Scan Error',
    SCAN_ERROR_BODY         : 'Please ensure the scanned accessory is correct in quantity and type',
  },
  ACCOUNT_CREATE_SUCCESS  : 'Account created successfully',
  ACCOUNT_CREATE_ERROR    : 'Account creation failed',
  ACCOUNT_CREATE_INFO     : 'Your account (%0) still needs to be verified. Please check your email.',
  ACCOUNT_CREATE_ERROR_INFO : 'User already exists. (%0)',
  ACCOUNT_VALIDATION_INFO: {
    MIN_LENGTH  : 'Minimum length {{passwordValidation.minLength}} characters',
    UPPER_CASE  : 'At least one uppercase letter',
    LOWER_CASE  : 'At least one lowercase letter',
    NUMBER      : 'At least one number',
    SPECIAL_CHAR: 'At least one special character',
    EMAIL_AVERY_REQUIRED: 'Registration is only allowed with @avery.com email addresses.',
    PASSWORD_SECURITY_REQUIREMENTS: 'Password does not meet the security requirements'
  },
  ACTIONS                 : 'Actions',
  ACTIVE                  : 'Active',
  ACTIVE_JOBS             : 'Active Jobs',
  ACTIVE_WORK             : 'Active Work',
  ADD                     : 'Add',
  ADD_BATCHES             : 'Add Batches',
  ADD_BATCHES_CONFIRM     : 'Are you sure you want to create new batches? This process is irreversible.',
  ADD_NEW_CONFIG          : 'Add New Config',
  ADD_BOX                 : 'Add Box',
  ADD_EMPLOYEE            : 'Add Employee',
  ADD_QR_CODE             : 'Add QR Code and switch to Laser cutting',
  ADD_SCRAP               : 'Add %0 sheets to scrap',
  ADD_TO_EOD              : 'Add to EoD',
  ADDRESS                 : 'Address',
  ADDRESS1                : 'Address 1',
  ADDRESS1_REQUIRED       : 'Address 1 is required',
  ADDRESS1_TOO_LONG       : 'Address 1 cannot exceed 35 characters',
  ADDRESS2                : 'Address 2',
  ADDRESS2_TOO_LONG       : 'Address 2 cannot exceed 35 characters',
  ADDRESS3                : 'Address 3',
  ADDRESS3_TOO_LONG       : 'Address 3 cannot exceed 35 characters',
  ADDRESS_AMBIGUOUS       : 'The provided address could not be found. Did you mean:',
  ADDRESS_NOT_FOUND       : 'The provided address could not be found.',
  ADDRESS_VALID           : 'Address is valid!',
  ADDRESS_VALIDATION      : 'Address Validation',
  ADDRESS_VALIDATED_UPS   : 'Validated by UPS',
  ADDRESS_VALIDATED_FEDEX : 'Validated by FEDEX',
  ADDRESS_NOT_VALID       : 'Address not valid',
  ADDRESS_INVALID         : 'Address Invalid',
  ADDRESS_LABEL           : 'Address Label',
  ADJUST_DIE_PRESSURE     : 'Adjust Die Pressure',
  ADMIN                   : 'Admin',
  ADMIN_CENTER            : 'Admin Center',
  ADMIN_VERIFIED          : 'Admin Verified',
  ALL                     : 'All',
  ALLOW_PARTIAL_REPRINT   : 'Allow Partial Reprint',
  ALL_BATCHES             : 'All Batches',
  ALL_FIELDS_REQUIRED     : 'All fields required',
  ALL_FIELDS_REQUIRED_INFO: 'Please complete all of the %0 fields.',
  ALL_JOBS                : 'All Jobs',
  ALL_ORDERS              : 'All Orders',
  ALL_SHIPMENTS           : 'All Shipments',
  ALREADY_HAVE_ACCOUNT    : 'Already have an account?',
  APPLY                   : 'Apply',
  ARE_YOU_SURE_TO_UPDATE  : 'Are you sure to update?',
  ARTWORK_ERROR           : 'Artwork Error',
  ARTWORK_IDENTIFIER      : 'Artwork Identifier',
  ARTWORK_SCALE_FACTOR    : 'Artwork Scale Factor',
  ARTWORK_STATUS          : 'Artwork Status',
  AMAZON                  : 'Amazon',
  AMAZON_ORDERS           : 'Amazon Orders',
  AMOUNT                  : 'Amount',
  AMAZON_MULTIBOX       : {
    HEADER       : 'Amazon Multi Box',
    WAITING      : 'Please wait while retrieving Multi Box Label.',
    ERROR        : 'Please notify Coordinator/Supervisor of shipping issue.'
  },
  APPROVE                 : 'Approve',
  APPROVE_ALL             : 'Approve All',
  APPROVED                : 'Approved',
  APPROVAL_REQUIRED       : {
    APPROVAL_REQUIRED                    : 'Approval Required',
    APPROVAL_REQUIRED_HEADER             : 'Approval Required To Proceed',
    APPROVAL_REQUIRED_LOGIN              : 'Login (Supervisor)',
    APPROVAL_REQUIRED_SIGNIN_DESCRIPTION1: 'Note: action must be checked and approved by a supervisor.',
    APPROVAL_REQUIRED_SIGNIN_DESCRIPTION2: 'Requirement: Please contact a supervisor to approve action by signing in',
    APPROVAL_REQUIRED_INVALID            : 'User is not admin / Invalid username or password',
  },
  ATTENTION_REQUIRED      : 'Attention Required',
  ATTRIBUTES              : 'Attributes',
  AVAILABLE_DIES          : 'Available Dies',
  AVAILABLE_HORIZONS      : 'Available Horizons',
  AVAILABLE_PRINTERS      : 'Available Printers',
  ACTIVATE_DIE_MATERIAL   : 'Please enable the %0 to release Job from hold.',
  BACK                    : 'Back',
  BACK_TO_BATCHES         : 'Back to Batch List',
  BACK_TO_PROFILE         : 'Back to Profile',
  BACK_TO_JOBS            : 'Back To Jobs List',
  BACK_TO_SHIPMENTS       : 'Back to Shipments List',
  BARCODE                 : 'Barcode',
  BATCH                   : 'Batch',
  BATCH_CREATED           : 'New Batch Created',
  BATCH_CREATED_INFO      : 'Batch "%0" has been created!',
  BATCH_CUTTING           : 'Batch Cutting',
  BATCH_DELETED           : 'Batch Deleted',
  BATCH_DELETED_INFO      : 'Batch "%0" has been removed!',
  BATCH_DETAILS           : 'Batch Details',
  BATCH_ID                : 'Batch ID',
  BATCH_INFO              : 'Batch Info',
  BATCH_LIST              : 'Batch List',
  BATCH_NOT_FOUND         : 'Oops! Batch "%0" was not found.',
  BATCH_STATUS            : 'Batch Status',
  BATCH_UPDATED           : 'Batch Updated',
  BATCH_UPDATED_INFO      : 'Batch "%0" has been updated.',
  BATCHED                 : 'Batched',
  BATCHES                 : 'Batches',
  BATCHES_NOT_FOUND       : 'This batch is currently not associated with any jobs.',
  BCB_PADDING             : 'Business Card Book Padding',
  BEGIN_CUTTING           : 'Begin Cutting',
  BEGIN_LAMINATING        : 'Begin Laminating',
  BIN                     : 'Bin',
  BIN_MANAGER             : 'Bin Manager',
  BIN_UPDATED             : 'Bin Updated',
  BIN_UPDATED_INFO        : 'Bin "%0" has been updated.',
  BINS                    : 'Bins',
  BINS_FULL               : ' Bins Full',
  BIN_FULL_BODY           : 'All Bins are full. Job reverted to previous status.',
  BINNED                  : 'Binned',
  BREAKS                  : 'Breaks',
  BUSINESS_UNIT           : 'Business Unit',
  BOTH_SIDES              : 'Both Sides',
  BOTTOM                  : 'Bottom',
  BOXED                   : 'Boxed',
  BOX_ADDED               : 'Box Added',
  BOX_REMOVED             : 'Box Removed',
  CAM                     : 'Cam',
  CAM_STATUS              : 'Cam Status',
  CARDS                   : 'Cards',
  CANCEL                  : 'Cancel',
  CANCEL_ORDER            : 'Cancel Order',
  CANCEL_ORDER_CONFIRM    : 'Are you sure you want to cancel this order?',
  CANCELLED               : 'Cancelled',
  CAPACITY                : 'Capacity',
  CAPACITY_CONFIG         : 'Capacity Configuration',
  CAPACITY_SETT           : {
    CURRENT_LOAD                    : 'Current Load',
    CURRENT_CAPACITY                : 'Current Capacity',
    HOURLY_CAPACITY                 : 'Hourly Capacity',
    HOURLY_AVG_CAPACITY             : 'Hourly Avg. Capacity',
    HOURLY_MAX_CAPACITY             : 'Hourly Max Capacity',
    DAILY_CAPACITY                  : 'Daily Capacity',
    DAILY_MAX_CAPACITY              : 'Daily Max Capacity',
    OPERATOR_HOURLY_AVG_CAPACITY    : 'Operator Hourly Avg. Capacity',
    OPERATOR_WORKING_HR_PER_DAY     : 'Operator Working Hours Per Day',
    WORKING_HR_PER_DAY              : 'Working Hours Per Day',
    SETUP_HOUR                      : 'Set-up Hours',
    SETUP_QTY                       : 'Set-up Qty',
    METRIC_SETTINGS                 : 'Metric Settings',
    LOAD_CAPACITY_SETTINGS          : 'Load & Capacity Settings',
    PERCENTAGE_WORKING              : 'Percentage of Working Process',
    LOAD_CAPACITY                   : 'Machine Capacity and Load Settings',
    METRIC_UPDATE_MSG               : 'The metric values are updated',
  },
  CARRIER                 : 'Carrier',
  CARRIER_FILTER          : 'Carrier Filter',
  CATEGORY                : 'Category',
  CELLS                   : 'Cells',
  CHANGE_CUT_MACHINE      : 'Change Cut Machine',
  CHANGE_CUT_MACHINE_ORDERS  : 'Change Cut Machine',
  CHANGE_CUT_MACHINE_CUSTOM_SIZE_NO_CHANGE : 'Custom Size jobs will not be changed',
  CHANGE_CUT_MACHINE_SELECT: 'Select Cut Machine: ',
  CHANGE_CUT_MACHINE_HELP: {
    TITLE: 'To change the cutting machine, please:',
    STEP1: 'Select the target machine you want to move jobs to',
    STEP2: 'Select or Search jobs from the list below',
    STEP3: 'Click the "Move Jobs" button to complete the change',  
  },
  CHANGE_INCLUDES_WHITE_INK: 'Change Includes White Ink',
  CHANGE_PREFERRED_CUTTING : 'Change Preferred Cutting',
  CHANGE_HOLD_REASON      : 'Change Hold Reason',
  CHANGE_HOLD_REASON_CONFIRM: 'Please enter a new hold reason for this %0',
  CHANGE_HORIZON           : 'Change Horizon',
  CHANGE_HORIZON_DESC      : 'Please select the horizon to change the batch to.',
  CHANGE_LASER             : 'Change Laser',
  CHANGE_LASER_DESC        : 'Please select the laser to change the batch to.',
  CHANGE_PASSWORD         : 'Change Password',
  CHANGE_PASSWORD_HELP    : 'Set a new password. Keep in mind that you will need to log in again afterwards.',
  CHANGE_TO               : 'Change To',
  CHANGES_SAVED           : 'Changes saved',
  CHANGES_SAVED_INFO      : 'Your %0 changes have been saved!',
  CHANGING_FROM           : 'Changing From',
  CHANGING_CARRIER_TYPE   : 'Carrier Type Changed',
  CHANGING_SERVICE_TYPE   : 'Service Type Changed',
  CHECK_STATUS            : 'Check Status',
  CHIP_MEMORY             : 'Chip Memory',
  CHIP_PART_NUMBER        : 'Chip Part Number',
  CHIP_TYPE               : 'Chip Type',
  CITY                    : 'City',
  CITY_TOO_LONG           : 'City cannot exceed 30 characters',
  CLEAR                   : 'Clear',
  CLONE                   : 'Clone',
  CLOSE                   : 'Close',
  CLOSED                  : 'Closed',
  COATING                 : 'Coating',
  COATED                  : 'Coated',
  COATER1                : 'Coater 1',
  COATER2                : 'Coater 2',
  CODE                    : 'Code',
  COLOR_TONES             : 'Color / Tones',
  COLLATED                : 'Collated',
  COLLATING               : 'Collating',
  COLLATING_SHEET_QTY     : 'Collating Set Qty',
  COLLATOR                : 'Collator',
  COMMENT                 : 'Comment',
  COMMENT_ERROR           : 'Comment cannot exceed 500 characters',
  COMMENT_TEXT            : 'Comment Text',
  COMPANY                 : 'Company',
  COMPANY_TOO_SHORT       : 'Company must be at least 3 characters long',
  COMPANY_TOO_LONG        : 'Company cannot exceed 35 characters',
  COMPLETED               : 'Completed',
  CONFIG_ALREADY_EXISTS   : 'Config already exists. Please try a different Subassembly and/or Presta.',
  CONFIG_DELETED          : 'Successfully deleted config.',
  CONFIGS_UPDATED         : 'Successfully updated configs.',
  CONFIGURE_STD_HORIZON   : 'Configure the Standard Horizon to cut',
  CONFIRM_DELETE          : 'Confirm Delete',
  CONFIRM_DELETE_CONFIG_MESSAGE: 'Are you sure you want to delete this configuration?',
  CONFIRM_PASSWORD        : 'Confirm Password',
  CONFIRM_PASSWORD_ENTRY  : 'Please confirm your password',
  CONFIRM_CHANGE_CUT_MACHINE: 'Are you sure you want to change the cutting machine?',
  CONFIRMED               : 'Confirmed',
  CONNECT                 : 'Connect',
  CONTINUE                : 'Continue',
  COORDINATOR             : 'Coordinator',
  COPIES                  : 'Copies',
  COUNT                   : 'Count',
  COUNTRY_CODE            : 'Country Code',
  COUNTRY_CODE_TOO_LONG   : 'Country Code cannot exceed 2 characters',
  CREATE                  : 'Create',
  CREATE_NEW_CONFIG       : 'Create New Config',
  CREATE_NEW_CONFIG_INFO  : 'Please enter the Subassembly and Presta to create a new configuration.',
  CREATE_ACCOUNT          : 'Create Account',
  CREATE_YOUR_ACCOUNT     : 'Create your account',
  CREATED_DATE            : 'Created Date',
  CSAPPROVAL              : 'CS Approval',
  CSHOLD                  : 'CS Hold',
  CURRENT_HORIZON         : 'Current Horizon',
  CURRENT_LASER           : 'Current Laser',
  CURRENT_MATERIAL        : 'Current Material',
  CURRENT_PRESSURE        : 'Current Pressure',
  CURRENT_PRINTERS        : 'Current Printers',
  CURRENT_SCANNERS        : 'Current Scanners',
  CURRENT_STATUS          : 'Current Status',
  CUSTOM_SIZE_JOB_ERROR : 'Custom size jobs cannot be switched to HORIZON cutting.',
  LASER_CONFIG_JOB_ERROR : 'This job is found in the list of Material and Presta Template settings for Laser.Cutting is disabled on Horizon.',
  CUSTOMER                : 'Customer',
  CUSTOMER_EMAIL          : 'Customer Email',
  CUSTOMER_ID             : 'Customer ID',
  CUSTOMER_REQUEST        : 'Customer Special Request',
  CUSTOMER_REQUEST_MSG    : 'Job needs to be cut ONLY on %0 machine',
  CUSTOMER_DATES          : 'Customer Requested Dates',
  CUSTOMER_DELIVERY_DATE  : 'Customer Delivery Date',
  CUSTOMER_DUE_DATE       : 'Customer Due Date',
  CUSTOM_SIZE             : 'Custom Size',
  CUTTING_TYPE            : 'Cutting Type',
  CUT                     : 'Cut',
  CUT_NEXT                : 'Begin Cutting',
  CUT_ON_LASER            : 'Cut on Laser',
  CUT_USER                : 'User for Cut Status',
  CUT_UPDATED             : 'Updated for Cut Status',
  CUT_DONE                : 'Done Cutting',
  CUTTING                 : {
    BEGIN: 'Begin Cutting',
    NAME : 'Cutting'
  },
  CUTTING_ERROR        : 'Job update failed. Please try again. If the problem persists, please contact an ADMIN.',
  DARK_BORDER_SCALE    : 'Dark Border Scale',
  DAYS_BEHIND_NBD      : '%0 day(s) behind Next Business Day',
  DAYS_DUE             : '%0 day(s)',
  DAYS_PAST_DUE        : '%0 day(s) behind',
  DAYS_UNTIL_DUE       : '%0 day(s) until',
  DAYS_UNTIL_DUE_HEADER: 'Days Until Due',
  DAYS                 : 'Days',
  SUBMITTED_TO_DFE     : 'Submitted to DFE',
  DEFAULT_PRESSURE     : 'Default Pressure',
  DELETE               : 'Delete',
  DELETE_ITEM_HEADER   : 'Delete %0',
  DELETE_ITEM_CONFIRM  : 'Are you sure you want to delete %1 "%0"?',
  DELIVERY_CONFIRMATION: 'Delivery Confirmation',
  DELIVERY_DATE        : 'Delivery Date',
  DELIVERY_EXPECTED    : 'Delivery Expected',
  DESCRIPTION          : 'Description',
  DESELECT_ALL         : 'Deselect All',
  DESIGN_DESCRIPTION   : 'Design Description',
  DID_YOU_SAVE_INLAYS  : 'Did you save the inlays?',
  DIE_MANAGER          : 'Die Manager',
  DIE_NUMBER           : 'Die Number',
  DIE_PRESSURE         : 'Die Pressure',
  DIE_PRESSURE_MAX_ERROR: 'Die Pressure must be less than %0',
  DIE_PRESSURE_MIN_ERROR: 'Die Pressure must be greater than %0',
  DIE_PRESSURE_MODIFIED: 'Die pressure is still being modified',
  DIE_PRESSURE_MULTIPLE_ERROR: 'Die Pressure must be a multiple of %0',
  DIENOTAVAILABLE      : 'Die N/A',
  DIE_SCANNED          : 'Die Scanned',
  DIE_INVALID          : 'Die is invalid. Please scan correct die.',
  DIE_INACTIVE         : 'Die is not activated',
  DIES                 : 'Dies',
  DIE                  : 'Die',
  DIE_LIST             : 'Die List',
  DISCONNECT           : 'Disconnect',
  DONE                 : 'Done',
  DONE_PICKING         : 'Done Picking',
  DOWN                 : 'Down',
  DOWNLOAD_REPORT      : 'Download Report',
  DROPSHIP_ORDER       : 'Dropship Order - Don\'t use Avery logo on anything! Use blank closing labels, sheets labels and boxes.',
  DROPSHIP_MSG         : 'Dropship order - I checked all rolls in the shipment and made sure the sheets have blank closing labels (no Avery logo) on them',
  DPO_HOLD             : 'DPO Hold Reason',
  DUE_DATE             : 'Due Date',
  DUE_DATE_PASSED      : 'day(s) past due',
  DUE_DATE_UPCOMING    : 'day(s)',
  DUE_LATER            : 'Due Later',
  DUE_TODAY            : 'Due Today',
  DUE_TOMORROW         : 'Due Tomorrow',
  DUE_NEXT_BUSINESS_DAY: 'Due Next Business Day',
  DUPLO                : 'Duplo',
  EDIT                 : 'Edit',
  EDIT_ADDRESS         : 'Edit Address',
  EDIT_PRODUCT         : 'Edit Product',
  EDIT_PROFILE         : 'Edit Profile',
  EDIT_SHIPPING_ADDRESS: 'Edit Shipping Address',
  EDIT_TEMPLATE        : 'Edit Template',
  EDIT_IMPOSITION_TEMPLATE: 'Edit Imposition Template',
  EDITADO_SHEET_QA     : 'Redownload Artwork Reprint Check',
  EDITADO_SHEET_QA_BODY_1: 'This job was Edited and Reprinted. ',
  EDITADO_SHEET_QA_BODY_2: 'Please check and make sure you have in your hands ',
  EDITADO_SHEET_QA_BODY_3: 'If you have a previous reprint please scrap this job.',
  EDITADO_REPRINTS       : 'Reprint',
  EFF_HEIGHT           : 'Effective Height',
  EFF_WIDTH            : 'Effective Width',
  EMAIL                : 'Email',
  EMAIL_CONFIG         : 'Email Configuration',
  EMAIL_INVALID        : 'Please enter a valid email',
  EMAIL_REQUIRED       : 'Email is required.',
  EMAIL_AVERY_REQUIRED : 'Avery email is required.',
  EMAIL_TOO_LONG       : 'Email cannot exceed 50 characters',
  EMPLOYEES            : 'Employees',
  END                  : 'End',
  ENGINEERING          : 'Engineering',
  ENTER_COMMENT        : 'Enter a comment:',
  ENTER_SCRAP          : 'Enter Scrap',
  ENTER_SCRAP_TOTALS   : 'Please enter scrap totals (sheet qty) for Batch',
  ENTER_SCRAP_TOTALS_JOBS   : 'Please enter scrap totals (sheet qty) for Job',
  EOD                  : {
    BATCHES_MISSING_SCRAP        : 'There are batches that need to be assigned scrap!',
    NAME                         : 'End Of Day',
    COMPLETED_INFO               : 'The EoD process has been completed!',
    DESCRIPTION_FEATURE1         : 'export all finished Shipments to Magento and Staging/ILS systems',
    DESCRIPTION_FEATURE2         : 'inform you whether or not the communication to the aforementioned services was successful',
    DESCRIPTION_FEATURE3         : 'generate an email report and send it to the distribution list',
    DESCRIPTION_HEADER           : 'The End of Day will...',
    INDICATE_EOD                 : 'Please indicate which EoD to process.',
    INDICATE_FEDEX               : 'Please indicate if this is a FedEx EoD.',
    INDICATE_LAST_OF_DAY         : 'Please indicate if this will be the last EoD being shipped for the day.',
    INDICATE_AMAZON             : 'Please indicate if this is a AMAZON DIRECT FUFILLMENT EoD.',
    INFO1                        : 'You may re-run the individual process in case of failures.',
    INFO2                        : 'You may also run multiple EoDs per day.',
    FAILED_INFO                  : 'The EoD process has failed!',
    HEADER                       : 'Process End of Day',
    HISTORY                      : 'EoD History',
    NEXT_BUSINESS_DAY            : 'Next Business Day',
    NEXT_BUSINESS_DAY_PLACEHOLDER: 'Select next business day',
    NO_SHIPMENTS                 : 'There are currently no pending/ready shipments.',
    PROCESS                      : 'Process new EoD',
    RETRY                        : 'Retry EoD',
    RUNNING                      : 'An EoD process is currently running.',
    START                        : 'Start EoD Process',
    UNASSIGNED_MID               : 'There are still MID shipments that have not yet been assigned to a yellow bag!',
  },
  EOD_COMPLETED               : 'EoD Complete',
  EOD_FAILED                  : 'EoD Failed',
  ESTIMATED_DELIVERY          : 'Estimated Delivery',
  ESTIMATED_DELIVERY_DATE     : 'Estimated Delivery Date',
  EXPORT_EXCEL                : 'Export Excel Sheet',
  FACILITIES                  : 'Facilities',
  FAILED                      : 'Failed',
  FILTER_BY_SUBASSEMBLY       : 'Filter by Subassembly',
  FILTER_BY_PRESTA            : 'Filter by Presta',
  FILTER_SUBASSEMBLY_PRESTA_INFO: 'Please enter the Subassembly and/or Presta to filter the list.',
  FILTERED                    : 'Filtered',
  FIND_DEFAULT_PRINTER        : 'Find Default Printer',
  FINISHING                   : 'Finishing',
  FINISHED                    : 'Finished',
  FINISH_BARCODE              : 'Finish Barcode',
  FINISH_CODE                 : 'Finish Code',
  FINISH_LAMINATING           : 'Finish Laminating',
  FINISH_TYPE                 : 'Finish Type',
  FINISHING_PROGRAM           : 'Finishing Program',
  FINISHING_SIGNS             : 'Finishing Signs',
  FINISHING_TEXTURE           : 'Finishing Texture',
  FINISHING_TYPE              : 'Finishing Type',
  FIRSTNAME                   : 'First Name',
  FIRSTNAME_TOO_LONG          : 'First Name cannot exceed 16 characters',
  FRONT                       : 'Front',
  FORGOT_PASSWORD             : 'Forgot your password?',
  FORGOT_PASSWORD_INSTRUCTIONS: 'Enter your email and we\'ll email you instructions on how to reset your password.',
  FORGOT_PASSWORD_SENT        : 'Password reset email sent. Follow the directions in the email to reset your password.',
  FORGOT_PASSWORD_SENT_ERROR  : 'That email does not exist in our system.',
  GENERATED_DATE              : 'Generated Date',
  GET_ESTIMATES               : 'Get Estimates',
  GHS_PRINT_PENDING           : 'GHS Print Pending',
  GLOVIA                      : 'Glovia',
  GLOVIA_STATUS               : 'Glovia Status',
  GROUP                       : 'Group',
  GRAPHIC_WIZARD              : 'Graphic Wizard',
  GRAPHTEC                    : 'Graphtec',
  GUILLOTINE                  : 'Guillotine',
  GO_TO_GHS                   : 'Go To GHS Jobs',
  GO_TO_STICKER_JOBS          : 'Go To Sticker Jobs',
  GO_TO_MANAGER               : 'Go To Manager',
  HEIGHT                      : 'Height',
  HELP                        : {
    ADMINS        : 'Admins',
    BATCHING      : 'Batching',
    BINNING       : 'Binning',
    HELP          : 'Help',
    PRINTER_CONFIG: 'Printer Config',
    WORK_BUCKETS  : 'Work Buckets',
  },
  HISTORY                           : 'History',
  HOLD                              : 'Hold',
  HOLD_BINS                         : 'Hold Bins',
  HOLD_LIST                         : 'Hold List',
  HOLD_JOB                          : 'Hold Job',
  HOLD_MODAL_OTHER_HEADER           : 'Enter a comment (required):',
  HOLD_MODAL_COMMENT_HEADER         : 'Enter a comment (optional):',
  HOLD_REASON_LENGTH_ERROR          : 'Comment cannot exceed 60 characters',
  HOLD_REASON                       : 'Hold Reason',
  HOLE_PUNCH                        : 'Hole Punch',
  'HOLE_PUNCH_1-4'                  : 'Hole Punch 1/4"',
  'HOLE_PUNCH_5-32'                 : 'Hole Punch 5/32"',
  HOME                              : 'Home',
  HORIZONS                          : 'Horizons',
  HORIZON                           : 'Horizon',
  HORIZON_1                         : 'Horizon 1',
  HORIZON1                          : 'Horizon 1',
  HORIZON_2                         : 'Horizon 2',
  HORIZON2                          : 'Horizon 2',
  HORIZON_3                         : 'Horizon 3',
  HORIZON3                          : 'Horizon 3',
  HORIZON_LIST                      : 'Horizon List',
  HORIZON_ACTIVE                    : 'Horizon Active',
  HORIZON_ASSIGNMENT                : 'Horizon Assignment',
  HORIZON_CONFIGURATION             : 'Horizon Configuration',
  HORIZON_SMARTSLITTER              : 'Horizon + Smart Slitter',
  HOURS                             : 'Hours',
  HUMAN_RESOURCE                    : 'Human Resource',
  ID                                : 'ID',
  IMAGES                            : 'Images',
  IMPRESO_HELP                      : 'Impreso Help',
  IMPOSED_PDF                       : 'Cut File PDF',
  IMPOSITION                        : 'Imposition',
  IMPOSITION_CONFIG                 : 'Imposition Configuration | %0',
  IMPOSITION_EDITOR                 : 'Imposition Editor',
  IMPOSITION_TEMPLATE_EDITOR        : 'Imposition Template Editor',
  INACTIVE                          : 'Inactive',
  INCLUDE                           : 'Include',
  INCLUDES_WHITE_INK                : 'Includes White Ink',
  INLAY_SHEETS_SCRAPPED             : 'How many inlay sheets were scrapped?',
  INFO_STRIP                        : 'Info Strip',
  INLINE_JOBCARD                    : 'Inline Job Card',
  INPACKING_STICKERS                : 'InPacking Stickers',
  INTERFACE                         : 'Interface',
  INTOUCH_ORDER                     : 'InTouch Order - Attach packing list to the outside of the box to indicate the contents.',
  IDCBAND_ORDER                     : 'ID&C Order - Attach packing list to the outside of the box to indicate the contents.',
  INTL_INVOICE_CONFIRM_HEADER       : 'Paper Invoice Required (Order %0)',
  INTL_INVOICE_CONFIRM_INFO         : 'Please take all copies of the paper invoice out of the packing slip printer, date and sign all pages and put them into a pouch on top of the package.',
  INTL_INVOICE_CONFIRM_INFO2        : 'Yes, I signed and dated the invoice and attached it to the package for Order %0',
  INVALID_DIE_ID_SCAN               : 'Die ID "%0" scanned, please scan "%1" instead',
  INVALID_MATERIAL_ID_SCAN          : 'Material Subassembly "%0" scanned, please scan "%1" instead',
  INVALID_WEIGHT                    : 'Shipments with a total weight above 150lbs need to be shipped via LTL Freight. Please contact Warehouse Team to arrange the LTL shipment.',
  INVALID_SCAN_ERROR_TITLE          : 'Bin Station Error for Job %0',
  INVALID_SCAN_ERROR_BODY           : "The status of Job <strong>%0</strong> is <strong>%1</strong>.<br><span>This job can't be moved to a bin.</span>",
  INVALID_SCAN_REASONS              : {
    CS_HOLD     : "Please take the job to CS team to review.",
    CSAPPROVAL  : "Please take the job to CS team to review.",
    SYSTEMS     : "Please take the job to Systems team to review.",
    QA          : "Please take the job to Quality team to review.",
    ENGINEERING : "Please take the job to Engineering team to review.",
    SHIPPING    :  "Please take the job to your Coordinator to review.",
    DIENOTAVAILABLE         :  "Please take the job to your Coordinator to review.",
    MATERIALNOTAVAILABLE    :  "Please take the job to your Coordinator to review.",
    OTHER                   :  "Please take the job to your Coordinator to review.",
    DPO         :  "Please take the job to your Coordinator to review.",
    CANCELLED     : "Please place job in Scrap tray.",
    EOD_COMPLETED : "Please place job in Scrap tray.",
  },
  INVOICE                           : 'Invoice',
  ITEMS_PER_SHEET                   : 'Items Per Sheet',
  JOB                               : 'Job',
  JOB_BATCHED                       : 'Job Batched',
  JOB_CUTTING                       : 'Job Cutting',
  JOB_DETAILS                       : 'Job Details',
  JOB_ID                            : 'Job ID',
  JOB_LIST                          : 'Job List',
  JOB_NOT_FOUND                     : 'Oops! Job "%0" was not found.',
  JOB_STATUS_UPDATED                : 'Job status updated',
  JOB_UPDATED                       : 'Job Updated',
  JOB_UPDATED_INFO                  : 'Job "%0" has been updated.',
  JOB_LOCATION_SCAN                 : 'Job Location Scan',
  JOB_SPECIFIC                      : 'Job Specific',
  JOBS                              : 'Jobs',
  JOBS_IN_BATCH                     : 'Jobs in this Batch',
  JOBS_IN_ORDER                     : 'Jobs in this Order',
  JOBS_IN_SHIPMENT                  : 'Jobs in this Shipment',
  JOBS_READY                        : 'Jobs ready',
  JOBS_UPDATED                      : 'Jobs Updated',
  JOBS_UPDATED_INFO                 : 'The following jobs have been updated:',
  LABEL                             : 'Label',
  LABEL_PRINT_ERROR                 : 'Label Printer Error',
  LABEL_PRINT_ERROR_INFO            : 'Could not print. Please double check your printer configuration.',
  LABELS                            : 'Labels',
  LABEL_CREATED                     : 'Label Created',
  LAMINATED                         : 'Laminated',
  LAMINATING                        : 'Laminating',
  LAMINATOR                         : 'Laminator',
  LANGUAGE                          : 'Language',
  LASER                             : 'Laser',
  LASER_CONFIGURATION               : 'Laser Configuration',
  LASER_FUNCTIONALITY: {
    ENABLE_LASER_CUTTING              : 'Enable Laser Cutting',
    ENABLE_LASER_CUTTING_FOR_JOBS     : 'Enable laser cutting for this die',
    LASER_ELIGIBLE                    : 'Laser Eligible',
    LASER_NOT_ELIGIBLE                : 'Not Eligible',
    MOVE_TO_LASER_CUTTING             : 'Move to Laser Cutting',
    SUSPEND_DIE                       : 'Suspend Die',
    EXISTING_JOBS_AFFECTED            : 'Existing Jobs Affected',
    EXISTING_DIES_AFFECTED            : 'Dies Affected',
    FUTURE_ORDERS_AFFECTED_WARNING    : 'Future orders using this die will be cut with laser until the die is enabled again.',
    LASER_ENABLED_INFO                : 'Existing jobs on HOLD due to this die will be changed to use laser cutting, and future jobs will use laser cutting instead of being put on HOLD.',
    LASER_DISABLED_INFO               : 'All jobs requiring this die will be put on HOLD until the die is enabled again.',
    TEMPLATE_LASER_DISABLED           : 'Template is NOT Enabled for Laser Cutting in Magento. It cannot be moved to Laser cutting'
  },
  LASER_ENABLED                     : 'Laser Enabled',
  LASER_ENABLED_MSG                 : 'Are you sure to update the Laser Enabled flag?',
  LASER_ENABLED_SUB_MSG             : 'By updating this flag, all nested configurations of this item will be updated too. If you want to add change to a specific pair of material and template then please go to nested configuration page.',
  LASER_MANIFEST                    : 'Laser Manifest',
  LASER_PRESTA_MATERIAL_CONFIG      : 'Laser Presta Subassembly Configuration',
  LAST_SHIPMENT_LINE                : 'Last Line for Shipment',
  LAST_SHIPMENT_LINE_HOLD           : 'Select at least one line to move to On Hold',
  LASTNAME                          : 'Last Name',
  LASTNAME_TOO_LONG                 : 'Last Name cannot exceed 16 characters',
  LAST_MONTH                        : 'Last Month',
  LAST_WEEK                         : 'Last Week',
  LATE                              : 'Late',
  LEFT                              : 'Left',
  LEVEL                             : 'Level %0',
  LIST_NETWORK_INFO                 : 'List Network Info',
  LINES                             : 'Lines',
  LAST_LOCATION                     : 'Last Location',
  LOCATION                          : 'Location',
  LOGIN                             : 'Login',
  LOGIN_HERE                        : 'Login Here',
  LOGOUT                            : 'Logout',
  LOGOUT_MSG                        : 'Logging out...',
  MACHINE                           : 'Machine',
  MACHINE_CAPACITY                  : 'Machine Capacity',
  MACHINE_LOCATION_SCANNERS         : 'Location Scanners',
  MAGENTO_ORDER_ID                  : 'Magento Order ID',
  MAGENTO_STATUS                    : 'Magento Status',
  MAKE_TO_STOCK                     : 'Make To Stock',
  MARGINS                           : 'Margins',
  MARKETPLACE_ORDER_NUMBER          : 'Marketplace Order Number',
  MARKETPLACE_ORDERS                : 'Marketplace Orders',
  MATERIAL                          : 'Material',
  MATERIAL_FINISH                   : 'Material Finish',
  MATERIAL_MANAGER                  : 'Material Manager',
  MATERIAL_NAME                     : 'Material Name',
  MATERIAL_SUBASSEMBLY              : 'Material Subassembly',
  MATERIALNOTAVAILABLE              : 'Material N/A',
  MATERIAL_SCANNED                  : 'Material Scanned',
  MATERIAL_INVALID                  : 'Material is invalid. Please scan correct material.',
  MATERIAL_INACTIVE                 : 'Material is not activated',
  MATERIAL_NESTED_CONFIG            : 'Material Nested Configuration',
  MEASUREMENT                       : 'Measurement',
  MESSAGE_TO_PRODUCTION             : 'Message To Production',
  MESSAGE_SPECIAL_REQUEST           : 'Enter a special request message',
  MISSING_ARTWORK_ERROR             : 'Missing Artwork Error',
  MISSING_BILLING                   : 'Missing Billing Information',
  MISSING_DUE_DATE                  : "Missing Due Date",
  MISSING_DELIVERY_DATE             : "Missing Delivery Date",
  MISSING_DATES                     : "Missing Dates",
  MISSING_SHEETS                    : 'Missing Sheets',
  MISSING_SETS                      : 'Missing Sets',
  MISSING_DATES_ERROR               : {
    JOB_ERROR                       : 'Cannot resume job with missing dates.',
    ORDER_ERROR                     : 'Cannot resume order with missing dates.',
    ERROR_BODY                      : 'Production due date and estimated delivery date must be populated before resuming the job or order.'
  },
  MOVE_TO_ON_HOLD                   : 'Move to On Hold',
  MOVE_TO_LAMINATED                 : 'Move to Laminated',
  MOVE_TO_LAMINATING                : 'Move to Laminating',
  MOVE_TO_SUPERBIN                  : 'Move to Superbin',
  MTO_ORDERS                        : 'MTO Orders',
  MTO_CARDS_PRODUCT                 : 'MTO Product',
  MTO_PRODUCT_INSTRUCTIONS          : 'MTO Products Packaging Instruction',
  MTS_WORKORDERS                    : 'Make to Stock Workorders',
  MTS_WORK_ORDER_INFO1              : 'Pending Make to Stock Work Orders: %0',
  MTS_WORK_ORDER_INFO2              : 'Print them now?',
  MULTI_LINE                        : 'Multi Line',
  MULTI_LINE_ORDER                  : 'Multi-Line Order',
  MY_PROFILE                        : 'My Profile',
  NAME                              : 'Name',
  NAVIGATE_TO_TEMPLATES             : 'Or, make a new template',
  NETWORK_INFO                      : 'Network Info',
  NETWORK_CONNECTION                : 'No Network Connection. Trying to reconnect...',
  NEW                               : 'New',
  NEW_PASSWORD                      : 'New Password',
  NEW_PASSWORD_REQUIRED             : 'Please enter a new password',
  NEW_PRESSURE                      : 'New Pressure',
  NEW_SHIPMENT_CREATED              : 'New Shipment Created',
  NEW_SHIPMENT_FINISHED             : 'Shipment Completed',
  NEW_SHIPMENT_CREATED_ERROR        : 'Could not create shipment',
  NEW_SHIPMENT_CREATED_ERROR_INFO1  : 'Sorry, something went wrong when attempting to create a shipment for Order',
  NEW_SHIPMENT_CREATED_ERROR_INFO2  : 'Please try again. If the problem persists, contact your system admin.',
  NEW_SHIPMENT_CREATED_INFO1        : 'has been created!',
  NEW_SHIPMENT_CREATED_INFO2        : 'Please use ',
  NEW_SHIPMENT_CREATED_INFO3        : 'For any jobs pertaining to Order',
  NEW_SHIPMENT_CREATED_INFO4        : 'Please note that since Order',
  NEW_SHIPMENT_CREATED_INFO5        : 'only contains 1 line, no bin has been assigned to this shipment.',
  NEW_SHIPMENT_CREATED_INFO6        : 'Please move order',
  NEW_SHIPMENT_CREATED_INFO7        : 'located in Bin #',
  NEW_SHIPMENT_CREATED_INFO8        : 'to the Shipping Station',
  NEW_SHIPMENT_CREATED_INFO9        : 'located in ',
  NEW_USER                          : 'New User',
  NEW_HOLDBIN_CREATED               : 'New Hold Bin Created',
  NEW_HOLDBIN_CREATED_INFO1         : 'Please use Hold Bin ',
  NEW_HOLDBIN_CREATED_INFO2         : 'for any Jobs pertaining to Order ',
  NEXT                              : 'Next',
  NEXTBUSINESSDAY                   : 'Next Business Day',
  NEXT_DAY                          : 'Next Day',
  NO                                : 'No',
  NO_BATCHES_TO_CUT                 : 'There are no more batches to cut!',
  NO_DIE_CUTTING_REQUIRED           : 'No Die Cutting Required',
  NO_DIE_REQUIRED                   : 'No die required.',
  NO_ELIGIBLE_REPRINT_JOBS          : 'There are no jobs eligible for reprint.',
  NO_SEARCH_RESULTS                 : 'No Search Results',
  NO_SEARCH_RESULTS_INFO            : 'Sorry, no matches found for "%0"',
  NO_SUPER_BIN_TITLE                : 'No Super Bin Available',
  NO_SUPER_BIN_BODY                 : 'No Super Bins Available. Please contact floor Admin.',
  NOT_OKAY_HOLD                     : 'Not OK / Hold',
  NONE                              : 'None',
  NOTES                             : 'Notes',
  NUMBER_OF_CELLS                   : 'Number of Cells',
  NUMBER_OF_COPIES                  : 'Number of Copies',
  NUMBER_OF_LINES                   : 'Number of Lines',
  NUMBER_OF_JOBS                    : '# of Jobs',
  NUMBER_OF_SHEETS                  : '# of Sheets',
  NUMBER_OF_SHEETS_MISSING          : '# of Sheets Missing',
  NUMBER_OF_SIDES                   : 'Number of Sides',
  OK                                : 'OK',
  OLD_PASSWORD                      : 'Old Password',
  OLD_PASSWORD_INCORRECT            : 'The old password you have entered is incorrect.',
  OLD_PASSWORD_REQUIRED             : 'Please enter your old password',
  OLD_PRESSURE                      : 'Old Pressure',
  ON_CREATE                         : '%0 created',
  ON_CREATE_ERROR                   : 'Could not create %0',
  ON_CREATE_ERROR_INFO              : 'Sorry, something went wrong when attempting to create the %0',
  ON_CREATE_INFO                    : 'Your new %0 has been created successfully!',
  ON_DELETE                         : '%0 deleted',
  ON_DELETE_INFO                    : 'Your %0 "%1" has been deleted successfully!',
  ON_HOLD                           : 'On Hold',
  ON_HOLD_BATCH_JOB_CONFIRM         : 'Placing this job on hold will remove it from this batch.',
  ON_HOLD_BATCH_JOB_CONFIRM_HEADER  : 'Please select a reason for placing this job on hold (Required).',
  ON_HOLD_BATCH_JOB_LAST            : 'This is the only remaining job in the batch. Placing this job on hold will remove this batch!',
  ON_HOLD_CONFIRM                   : 'Please select a reason for placing this %0 on hold (Required).',
  ON_HOLD_HEADER                    : 'Hold %0',
  ON_HOLD_DIE_WARNING_HEADER        : 'Note: This will Hold the current job\'s Die. Holding the Die will put all Jobs on Hold that share the same Die.',
  ON_HOLD_MATERIAL_WARNING_HEADER   : 'Note: This will Hold the current job\'s Material. Holding the Material will put all Jobs on Hold that share the same Material.',
  ON_LASER                          : 'On Laser',
  ON_NOT_LOADED_ERROR               : '%0 not loaded',
  ON_NOT_LOADED_ERROR_INFO          : 'Sorry, we could not load any %0 data',
  ON_TIME                           : 'On Time',
  ON_UPDATE_ERROR                   : 'Could not update %0',
  ON_UPDATE_ERROR_INFO              : 'Sorry, something went wrong when attempting to update the %0',
  ON_UPLOAD                         : '%0 uploaded',
  ON_UPLOAD_INFO                    : 'Your %0 "%1" has been uploaded successfully!',
  ON_UPLOAD_ERROR                   : 'Could not upload %0',
  ON_UPLOAD_ERROR_INFO              : 'Sorry, something went wrong when attempting to upload the %0',
  ONPRESS_REASON                    : 'OnPress Reason',     
  ONPRESS_UPDATED                   : 'OnPress Updated',     
  ONESIDED                          : 'One Sided',
  OPEN                              : 'Open',
  OPEN_BATCH                        : 'Open Batch',
  OPEN_PDF                          : 'Open PDF',
  OPENED                            : 'Opened',
  ORDER                             : 'Order',
  ORDER_AND_YB_ID                   : 'Order / Yellow Bag ID',
  ORDER_CANCELLED_HEADER            : 'Order Cancelled',
  ORDER_CANCELLED_INFO              : 'Order "%0" has been successfully cancelled',
  ORDER_DATE                        : 'Order Date',
  ORDER_DETAILS                     : 'Order Details',
  ORDER_DETAILS_HEADER              : 'Order %0',
  ORDER_DETAILS_BACK                : 'Back to Orders List',
  ORDER_DESCRIPTION                 : 'Order Description',
  ORDER_ID                          : 'Order ID',
  ORDER_ERROR_TITLE                 : 'Order Error Scan',
  ORDER_ERROR_BODY                  : 'A sheet from a different order was scanned. Please check all jobs from this order.',
  ORDER_FOUND_WRONG_SYSTEM          : 'Order Found, Wrong System',
  ORDER_FOUND_WRONG_SYSTEM_INFO1    : 'The ID (<strong>%0</strong>) you scanned belongs to an order in a different system.',
  ORDER_FOUND_WRONG_SYSTEM_INFO2    : '<strong>Current System</strong>: %0',
  ORDER_FOUND_WRONG_SYSTEM_INFO3    : '<strong>Scanned System</strong>: %0',
  ORDER_NOT_FOUND                   : 'Oops! Order "%0" was not found.',
  ORDER_PAST_DUE                    : 'This Order is %0 day(s) past due!',
  ORDER_STATUS_UPDATED              : 'Order status updated',
  ORDER_UPDATED                     : 'Order Updated',
  ORDER_UPDATED_INFO                : 'Order "%0" has been updated.',
  ORDERED_TOTAL                     : 'Ordered Total',
  ORDERED_QTY                       : 'Ordered Qty',
  ORDERS                            : 'Orders',
  ORDERS_CUT                        : 'Orders Cut',
  ORDERS_LIST                       : 'Orders List',
  ORDERS_RECEIVED                   : 'Orders Received',
  ORDERS_UPDATED                    : 'Orders Updated',
  ORDERS_UPDATED_INFO               : 'The following orders have been updated:',
  ORIGIN                            : 'Origin',
  ORIGINAL_DUE_DATE                 : 'Original Due Date',
  ORIGINAL_SERVICE_TYPE             : 'Original Service Type',
  OTHER                             : 'Other',
  OTHER_REASON                      : 'Other Reason',
  OTHER_REASON_REQUIRED             : 'Please provide an Other Reason.',
  OVER_COUNT_TITLE                  : 'Over Count Error',
  OVER_COUNT_BODY                   : "Correct number of sheets for Job %0 have already been scanned. Please move on to the next job.",
  OVERDUE                           : 'This %0 is overdue by %1 day(s)',
  OVERLAY                           : 'Overlay',
  OVERLAY_ADD_DELETE                : 'Add/Delete Overlay',
  OVERLAY_DELETE_ERROR              : 'Template overlay PDF delete error',
  OVERLAY_DELETE_ERROR_INFO         : 'Something went wrong when trying to delete the template overlay PDF',
  OVERLAY_FILE                      : 'Overlay File',
  OVERLAY_FILE_CURRENT              : 'Current Overlay File',
  OVERLAY_FILE_SELECT               : 'Select an overlay file',
  OVERLAY_FILE_SELECT_INFO          : 'Or, upload a PDF of your choosing',
  OVERLAY_MANAGE                    : 'Manage Overlays',
  OVERLAY_MANAGER                   : 'Overlay Manager',
  OVERLAY_PDF                       : 'Overlay PDF',
  OVERLAYS                          : 'Overlays',
  OVERLAYS_MISSING                  : 'Missing Overlays',
  OVERWEIGHT                        : 'Max 150 lbs per box',
  PACKAGE_NUMBER                    : 'Package Number',
  PACKAGE_MATERIAL                  : 'Package Material',
  PACKAGE_TYPE                      : 'Package Type',
  PACKED                            : 'Packed',
  PACKAGES                          : 'Packages',
  PACKING                           : 'Packing',
  PACKING_JOBS                      : 'Job still in Packing',
  PACKING_STILL_IN                  : ' still in Packing.',
  PACKING_FINISH                    : 'Please finish Packing and move to Shipping before starting to pack another Job.',
  PACKING_SLIP                      : 'Packing Slip',
  PACKING_SLIP_PRINT_SUCCESS        : 'Packing Slip Printed',
  PACKING_SLIP_PRINT_SUCCESS_INFO   : 'The packing slip for Order "%0" has been printed from "%1".',
  PACKAGE_MATERIAL_NEEDED_ERROR     : 'Package Material Error',
  PACKAGE_MATERIAL_NEEDED_ERROR_BODY : 'Package Material cannot be left empty. Please add at least one Bocket.',
  PACKAGING_LABEL                   : 'Packaging Label',
  PACKAGING_LABEL_MODAL_HEADER      : 'Print Packaging Label',
  PACKAGING_LABEL_PRINT_INSTRUCTION : 'Enter the number of sheets going into the package and click print.',
  PACKAGING_LABEL_PRINT_SUCCESS     : 'Packaging Label Printed',
  PACKAGING_LABEL_PRINT_SUCCESS_INFO: 'The packing label for Job "%0" has been printed from "%1".',
  PACKAGING_USER                    : 'User for Packaging Status',
  PACKAGING_UPDATED                 : 'Updated for Packaging Status',
  PAGE_FROM                         : 'Press Sheet From',
  PAGE_FROM_ERROR1                  : 'Page From can not be lower then Page To.',
  PAGE_FROM_ERROR2                  : 'Page From can not be lower then or equal to Previous Page To.',
  PAGE_FROM_ERROR1N2                : 'Page From can not be lower then Page To. Page From can not be lower then or equal to Previous Page To.',
  PAGE_NOT_A_NUMBER                 : 'Page is not a number',
  PAGE_RANGE_INVALID                : 'Invalid page range, use e.g. 1 to 5, 11 to 11',
  PAGE_TO                           : 'Press Sheet To',
  PAGE_SCAN_MSG                     : 'Please scan each page of job',
  PAGES                             : 'Pages',
  PARENT_TRACKING_NUMBER            : 'Parent Tracking Number',
  PARTIAL_RECUT                     : 'Only cut a portion of the original %0 sheets',
  PARTIAL_REPRINT                   : 'Partial Reprint',
  PASSWORD                          : 'Password',
  PASSWORD_MATCH_REQUIRED           : 'The provided passwords do not match',
  PASSWORD_REQUIRED                 : 'Please enter a password.',
  PASSWORD_UPDATED                  : 'Password Updated',
  PASSWORD_UPDATED_INFO             : 'Your password has been successfully updated!',
  PAST_7_DAYS                       : 'Past 7 Days',
  PAST_DUE                          : 'Past Due',
  PENDING                           : 'Pending',
  PENDING_PRINTING                  : 'Pending Printing',
  PENDING_PRINTING_WARN             : 'Order %0 is currently Pending Printing. Only a member of Customer Service can release it.',
  PENDING_PRINTING_CS_BODY          : 'Job is in Pending Printing status, please take it to a member of the Customer Service team for review.',
  PENDING_SHIPMENT                  : 'Pending Shipment',
  PENDING_SHIPMENTS                 : 'Pending Shipments',
  PENDING_TASKS                     : 'You have %0 pending task(s)',
  PERCENT_OF_JOBS                   : '% of Jobs',
  PERCENT_OF_SHEETS                 : '% of Sheets',
  PHONE                             : 'Phone',
  PHONE_NUMBER_REQUIRED             : 'Phone number required for non-US shipment',
  PHONE_NUMBER_VALID_DOMESTIC_FORMAT: '10 digits required',
  PHONE_NUMBER_CHARACTER            : 'Please input numbers only',
  PHYSICAL_ADDRESS                  : 'Physical Address',
  PLEASE_CHECK                      : 'Please check the following points:',
  PLEASE_CONFIRM                    : 'Please Confirm',
  PLEASE_ENTER_PASSWORD             : 'Please enter a password',
  PLEASE_SELECT_DATE                : 'Please Select Date',
  PLEASE_SELECT_HORIZON             : 'Please select a horizon',
  POSITION_FACE_DOWN                : 'Please position the artwork side face down',
  POSITION_FACE_UP                  : 'Please position the artwork side face up',
  POSTCODE_REQUIRED                 : 'Postcode Required',
  POSTCODE_VALID_FORMAT_CA          : 'Valid zip: A#A#A#',
  POSTCODE_VALID_FORMAT_INTL        : 'Valid zip: 9 alphanumeric characters',
  POSTCODE_VALID_FORMAT_INTL_LENGTH : 'Postcode must be less than 9 characters',
  POSTCODE_VALID_FORMAT_US          : 'Valid zip: XXXXX-YYYY OR XXXXX OR XXXXXYYYY',
  PREFERRED_CUTTING                 : 'Preferred Cutting',
  PREFERRED_CUTTING_WARNING         : 'Preferred cutting changed to %0 and is different from original preferred cutting',
  PREPRESS                          : 'Prepress',
  PREPRINT                          : 'Preprint',
  PRESSES                           : 'Presses',
  PRESSURES                         : 'Pressures',
  PRESTA                            : 'Presta',
  PRINT                             : 'Print',
  PRINT_AND_BOX                     : 'Print & Box',
  PRINT_AND_SHIP                    : 'Print, Box, Ship',
  PRINT_READY                       : 'On Press',
  PRINT_READY_NEXT                  : 'Ready for print',
  PRINT_STATION                     : 'Print Station',
  PRINT_PROOF                       : 'Print Proof',
  PRINT_WORK_ORDERS                 : 'Print Work Orders',
  PRINTED                           : 'Printed',
  PRINTED_NEXT                      : 'Done printing',
  PRINTED_REASON                    : 'Printed Reason',
  PRINTED_UPDATED                   : 'Printed Updated',
  PRINTER                           : 'Printer',
  PRINTER_CONFIGURATION             : 'Printer Configuration',
  PRINTER_CONNECTION                : 'Connection to Printer',
  PRINTER_FOUND                     : 'Printer Found',
  PRINTING                          : 'Printing',
  PRINTING_ABORTED                  : 'Printing Aborted',
  PRINTREADY                        : 'On Press',
  PROBLEM                           : 'Problem',
  PROCESS_SCRAP                     : 'Process Scrap',
  PROCESSING                        : 'Processing',
  PRODPENDING                       : 'Prod Pending',
  PROD_PENDING_PRINTING             : 'Production Pending Print',
  PRODUCT                           : 'Product',
  PRODUCT_CLONE                     : 'Clone Product',
  PRODUCT_CLONE_INFO                : 'Enter a new name for the product clone of "%0" below',
  PRODUCT_CREATE_HELP               : 'Or, create a new product by entering the product name',
  PRODUCT_CREATED                   : 'New Product Created',
  PRODUCT_CREATED_INFO              : 'Product "%0" has been created!',
  PRODUCT_CONFIG                    : 'Product Configuration | %0',
  PRODUCTION_DATES                  : 'Production Dates',
  PRODUCT_DELETE                    : 'Product Deleted',
  PRODUCT_DELETE_INFO               : 'Product "%0" has been deleted!',
  PRODUCT_DELETE_CONFIRM            : 'Are you sure you want to delete "%0"?',
  PRODUCT_ID                        : 'Product ID',
  PRODUCT_INFO                      : 'Product Info',
  PRODUCT_NAME                      : 'Product Name',
  PRODUCT_NEW                       : 'New Product',
  PRODUCT_RENAME                    : 'Rename Product',
  PRODUCT_RENAME_INFO               : 'Enter a new name for "%0"',
  PRODUCT_SELECT                    : 'Select a Product',
  PRODUCT_SELECT_HELP               : 'Modify, clone from, or delete an existing product',
  PRODUCT_SKU                       : 'Product SKU',
  PRODUCT_SUBASSEMBLY_CREATE        : 'New Product Subassembly Created',
  PRODUCT_SUBASSEMBLY_CREATE_INFO   : 'Product subassembly "%0" has been created!',
  PRODUCT_SUBASSEMBLY_DELETE        : 'Product Subassembly Deleted',
  PRODUCT_SUBASSEMBLY_DELETE_INFO   : 'Product subassembly "%0" has been deleted!',
  PRODUCT_SUBASSEMBLY_UPDATED       : 'Product Subassembly Updated',
  PRODUCT_SUBASSEMBLY_UPDATED_INFO  : 'Product Subassembly "%0" has been updated.',
  PRODUCT_UPDATED                   : 'Product Updated',
  PRODUCT_UPDATED_INFO              : 'Product "%0" has been updated.',
  PRODUCTION_DUE                    : "Production Due",
  PRODUCTION_DUE_DATE               : 'Production Due Date',
  PRODUCTS                          : 'Products',
  PRODUCTS_UPDATED                  : 'Products Updated',
  PRODUCTS_UPDATED_INFO             : 'The following products have been updated:',
  PROFILE                           : 'Profile',
  PROGRESS                          : 'Progress',
  PROMOTION                         : 'Promotional Order',
  PROMOTIONAL_ORDERS                : 'Promotional Orders',
  PROOF                             : 'Proof',
  PROOF_STATUS                      : 'Proof Status',
  PTO_BATCHES                       : 'PTO Batches',
  PTO_RACKS                         : 'PTO Racks',
  PTO_JOB                           : 'PTO Job',
  PTO_ORDERS                        : 'PTO Orders',
  PTO_SCAN                          : 'PTO Scan',
  PTO_SCAN_INVALID                  : 'PTO Scan Invalid',
  PTO_WORK_ORDER                    : 'PTO Work Order',
  PTO_PACKAGING_LABEL               : 'PTO Packaging Label',
  PTO_SCAN_INSTRUCTIONS             : 'Ensure the printer is configured with the following and proceed to print',
  PTO_MAKE_TO_STOCK                  : 'Make To Stock: After printing, this job will go to Packing.',
  PTO_NO_MORE_BATCHES                : 'No more batches to process',
  PTO_NO_MORE_BATCHES_INFO           : 'You\'re all caught up.',
  PTO_BINS_TOTAL                     : 'Total Bins',
  PTO_BINS_OCCUPIED                  : 'Occupied Bins',
  PTO_BINS_AVAILABLE                 : 'Available Bins',
  PTO_BINS_AVAILABLE_STATUS          : 'Available',
  PTO_BINS_READY_FOR_NEXT_BATCH      : 'Ready for next batch',
  PTO_BINS_NO_BINS_AVAILABLE         : 'No PTO Bins Available',
  PTO_BINS_CLICK_INIT                : 'Click "Init Bins" to create the initial 20 PTO bins in the database.',
  POSITION                          : 'Position',
  POSTAL_CODE                       : 'Postal Code',
  PO_BOX_BLOCK                      : 'PO Box Service Type cannot be changed.',
  QA                                : 'QA',
  QAOK                              : 'QA OK',
  HOLD_BIN_MANAGER                  : 'Hold Bin Manager',
  QAOK_FULL                         : 'No Shipping Stations Available',
  QAOK_FULL_BODY_1                  : 'No more than %0 shipments can be in status QA OKAY.',
  QAOK_FULL_BODY_2                  : 'Please finish shipments for order(s) %0 %1 first.',
  QA_HOLD_PROMPT                    : 'Select jobs with quality issues and add a hold reason (required): ',                
  QA_CHECK_FOR_ORDER                : 'QA Check for Order',
  QA_CHECK_JOB                      : 'Please check each job for the following: ',
  QA_CHECK_JOB_LIST                 : 'Number of Sheets, Print Quality, Damaged / Scratched / Missing Sheets, Coating',
  QA_CHECK                          : 'QA Check',
  QAOK_USER                         : 'QAOK User',
  QAOK_REASON                       : 'QAOK Reason',
  QAOK_UPDATED                      : 'QAOK Updated',
  QTY                               : 'Qty',
  QTY_AND_MEASUREMENTS              : 'Qty & Measurements',
  QTY_ORDERED                       : 'Qty Ordered',
  QTY_REMAINING                     : 'Qty Remaining',
  QUANTITY                          : 'Quantity',
  QUANTITY_MUST_BE_POSITIVE         : 'Quantity must be positive',
  QUEUED                            : 'Queued',
  QUEUED_IN_IMPRESO                 : 'Queued',
  READY                             : 'Ready',
  REASON                            : 'Reason',
  RECUT                             : 'Recut',
  RECUT_BODY                        : 'Would you like to recut this job?',
  RECUT_HEADER                      : 'Recut Job',
  RECUT_QTY                         : 'Recut Qty',
  RECUT_SHEETS                      : 'Recut %0 sheets',
  REDOWNLOAD                        : 'Redownload',
  REDOWNLOAD_DPO_ART                : 'Redownload Artwork from DPO',
  REDOWNLOAD_ARTWORK                : 'Re-download changed artwork from DPO',
  REENTER_PASSWORD                  : 'Verify Password',
  REENTER_PASSWORD_MATCH            : 'The provided passwords do not match.',
  REENTER_PASSWORD_REQUIRED         : 'Please verify your password.',
  REGEN_LASER                       : 'Regen Laser Files',
  REGEN_PDF                         : 'Regen PDF',
  REGEN_LASER_BODY                  : 'Laser files have been regenerated successfully.',
  REGIONS                           : 'Regions',
  REGISTER                          : 'Register',
  REGISTER_NOW                      : 'Register Now',
  REJECT                            : 'Reject',
  REJECT_ALL                        : 'Reject All',
  REJECTED                          : 'Rejected',
  RELEASE_CS                        : 'Release CS',
  REMEMBER_PASSWORD                 : 'Remember your password?',
  REMOVE                            : 'Remove',
  REMOVE_PACKAGE_BOX                : 'Remove Package Box',
  RENAME                            : 'Rename',
  REPLACE                           : 'Replace',
  REPLACE_DIE                       : 'Replace Die',
  REPLACE_DIE_CONFIRM               : 'Are you sure you want to replace this die & reset it to its default die pressure values?',
  REPORT                            : 'Report',
  REPORT_FILE                       : 'Report File',
  REPORT_SCRAP                      : 'Report Scrap',
  REPORT_STATUS                     : 'Report Status',
  REPORTS                           : {
    REPORTS: 'Reports',
    EQUIPMENT_UTIL   : 'Equipment Utilization',
    END_OF_MONTH     : 'End of Month',
    ORDER_COMPLETION : 'Order Completion',
    ORDER_SHIPMENT: 'Order / Shipment',
    SCRAP_REPRINT: 'Scrap / Reprint',
    REPRINT: 'Reprint',
    CUSTOMER_SERV : 'Customer Service',
    ORDERS_REPORT: 'Orders Report',
    COMPLAINT: 'Complaint Report',
    MATERIAL_USAGE: 'Material Usage Report',
    SYSTEM_FLOWCHART: 'System Flowchart',
    CAPACITY_REPORT: 'Capacity Report',
    EOM_REPORT: 'End of Month Report',
    EOM: {
      TOTAL_SHIPMENTS: 'Total Shipments',
      TOTAL_PACKAGES: 'Total Packages',
      TOTAL_SHIPPING_COSTS: 'Total Shipping Costs',
      AVG_COST_PER_SHIPMENT: 'Avg Cost Per Shipment',
      SHIPMENTS_BY_CARRIER: 'Shipments by Carrier',
      SHIPPING_COSTS_BY_CARRIER: 'Shipping Costs by Carrier',
      SHIPMENTS_BY_BUSINESS_UNIT: 'Shipments by Business Unit',
      DAILY_SHIPPING_COST_TRENDS: 'Daily Shipping Cost Trends',
      COST_ANALYSIS_SUMMARY: 'Cost Analysis Summary',
      CARRIER_PERFORMANCE: 'Carrier Performance',
      BUSINESS_UNIT_PERFORMANCE: 'Business Unit Performance',
      SHIPMENT_SUMMARY: 'Shipment Summary',
      EOM_SHIPMENT_DETAILS: 'EOM Shipment Details',
      SHIPMENT_DETAILS: 'Shipment Details',
      NO_EOM_DATA: 'No EOM data available for the selected date range.',
      NO_DRIVER_SUMMARY: 'No driver summary data available',
      CARRIER: 'Carrier',
      SHIPMENTS: 'Shipments',
      TOTAL_COST: 'Total Cost',
      AVG_COST_SHIPMENT: 'Avg Cost / Shipment',
      BUSINESS_UNIT: 'Business Unit',
      SERVICE_TYPE: 'Service Type',
      SHIPMENTS_PACKAGES: 'Shipments / Packages',
      DATE: 'Date',
      ORDER_ID: 'Order ID',
      ACCOUNT_NUMBER: 'Account Number',
      WEIGHT_LBS: 'Weight (lbs)',
      PACKAGES: 'Packages',
      SHIPPING_COST: 'Shipping Cost',
      COST_PACKAGE: 'Cost/Package',
      COST_POUND: 'Cost/Pound',
      DESTINATION: 'Destination',
      ACTIONS: 'Actions',
      TRACKING_NUMBER: 'Tracking Number',
      WEIGHT: 'Weight',
      AVG_COST_PER_PACKAGE: 'Average Cost Per Package',
      COST_PER_POUND: 'Cost Per Pound',
      SHEETS: 'Sheets',
      ONLINE_AISLE: 'Online Aisle',
      RFID: 'RFID'
    }
  },
  REPRINT           : 'Reprint',
  REPRINT_HEADER    : 'Reprint %0',
  REPRINT_REASON_TABLE : 'Reprint Reason',
  REPRINT_JOB_LIST  : 'Reprint Job List',
  REPRINT_LABEL     : 'Reprint Label',
  REPRINT_MANIFEST     : 'Reprint Manifest',
  REPRINT_ORDER_INFO: 'WARNING: Reprinting this order will remove any bins and shipments associated with this order!',
  REPRINT_RANGE     : 'Sheet Range',
  REPRINT_REASON    : {
    HORIZON_ADJUSTMENT : 'Ajuste Horizon',
    DUPLO_ADJUSTMENT   : 'Ajuste Duplo',
    SMARTSLITTER_ADJUSTMENT : 'Ajuste Smart Slitter',
    MISSING_SHEETS     : 'Hojas Faltantes',
    TOTAL_LOSS         : 'Perdida Total',
    JAMMING            : 'Atoramiento',
    EDITED             : 'Editado',
    DIRTY_MATERIAL     : 'Material Sucio',
    PIP_MARKS_LINES_DOTS : 'Marcas de PIP / Mantilla / Rayas / Puntos',
    TONES              : 'Tonos',
    PROBLEMS_COATING   : 'Problemas con Coating',
    DAMAGED_IN_PUNCHER : 'Dañado por el ponchado o perforado',
    CPR                : 'CPR',
    MATERIAL_DAMAGED_TRANSIT : 'Material dañado por traslado',
    BAD_CUT            : 'Mal Corte por TPH',
    POROUS_MATERIAL    : 'Material Poroso',
    INCORRECT_TEMPLATE : 'Template / Nombre del Producto Incorrecto',
    INCORRECT_MATERIAL : 'Material equivocado',
    INK_ADHERENCE      : 'Adherencia de tinta / descarapelado',
    DIRTY_GUILLOTINE   : 'Navaja de Guillotina sucia / desgastada',
    DUPLEX             : 'Duplex',
    JOB_STUCK          : 'Trabajo atorado',
    PROBLEM_JOB        : 'Problema de trabajo',
    LASER_CUT_WRONG    : 'Mal Corte en Laser'
  },
  REPRINT_REASON_HEADER             : 'Please select a reason for reprinting this %0 (Required)',
  REPRINT_SELECTED_PAGES            : 'Only reprint selected sheets of this job',
  REPRINT_SIDE                      : 'Select Side to Reprint',
  REPRINT_NUM_PAGES                 : 'Only reprint inputted number of pages',
  REPRINT_PAGES                     : 'Please specify the number of sheets to reprint (Required)',
  REPRINT_WORKORDERS                : 'Reprint Work Orders',
  REPRINT_OKAY                      : 'Reprint Okay',
  REQUIRED                          : 'Required',
  REQUIRED_BY_OPERATOR              : 'Required by operator',
  RESEND_TO_DFE                     : 'Resend to DFE',
  RESET                             : 'Reset',
  RESET_PASSWORD                    : 'Reset Your Password',
  RESET_PASSWORD_DESCRIPTION        : 'Create a new password',
  RESET_PASSWORD_ERROR              : 'The provided email and/or token does not match.',
  RESET_PASSWORD_SHORT              : 'Reset Password',
  RESET_PASSWORD_SUCCESS            : 'Password Reset Success',
  RESET_PASSWORD_USER               : 'Reset User Password',
  RESET_PASSWORD_ADMIN_ERROR        : 'Need to be an administrator to change user password',
  RESET_PASSWORD_USER_ERROR         : 'You have entered an invalid password',
  RESET_PASSWORD_ROLE_ERROR         : 'User is an administrator. Password cannot be reset.',
  RESUME                            : 'Resume',
  RESUME_NEXT                       : 'Resume, Next',
  REVERT_TO_SEALED                  : 'Revert to Sealed',
  RESUME_JOB_HOLD                   : 'Reanudar el trabajo en espera',
  RESUME_ORDER_HOLD                 : 'Reanudar la orden de espera',
  RFID_SCANNED                      : 'RFID Code Scanned',
  RFID_SAMPLES                      : 'RFID Samples',
  RFID_SAMPLE_JOB                   : 'RFID Sample SKU Job',
  RFID_ERROR_CODE_SCAN              : 'Scanned code does not match any expected code. Please scan correct code.',
  RFID_INVALID                      : 'RFID Code Invalid',
  RFID_OUTERCASE_LABELS             : 'RFID Outer Case Labels',
  RFID_INNERCASE_LABEL              : 'RFID Inner Case Label',
  RFID_VALIDATION                   : 'RFID Validation',
  RFID_COUNT_ERROR                  : 'Number of Qty is incorrect. Please count and enter number again',
  RFID_COUNT_SUCCESS                : 'Thank you. Please move job to packing',
  RFID_REPRINT_HEADER               : 'RFID Reprint',
  RFID_CARDS_PER_SHEET              : 'RFID Cards per Sheet',
  RFID_CARDS                        : 'RFID Cards',
  RFID_WAITING_UPLOAD               : 'Waiting to upload...',
  RFID_UPLOAD_COMPLETE              : 'Upload Success',
  RFID_SCRAP : {
    ENTER_RFID_SCRAP: "Enter RFID Scrap",
    SCRAP_CATEGORY: "Scrap Category",
    SELECT_CATEGORY: "Select Category",
    SCRAP_REASON: "Scrap Reason",
    SELECT_REASON: "Select Reason",
    SCRAP_QUANTITIES: "Scrap Quantities",
    FRONT_SHEETS: "Front Sheets",
    BACK_SHEETS: "Back Sheets",
    INLAY_SHEETS: "Inlay Sheets",
    FRONT_LAMINATE: "Front Laminate",
    BACK_LAMINATE: "Back Laminate",
    AT_LEAST_ONE_QUANTITY_REQUIRED: "At least one quantity must be greater than zero",
    CATEGORY_REQUIRED: "Category is required",
    REASON_REQUIRED: "Reason is required"
  },
  COUNT_VALIDATION_INSTRUCTION     : 'Please count the quantity on hand from this job and enter the number to validate',
  ENTER_TOTAL_CARDS                : 'Enter total number of cards',
  KIND                             : 'Kind',
  EXPECTED_COUNT                   : 'Expected Count',
  MISSING_CARDS_INFO               : 'Card Count Information',
  EXPECTED                         : 'Expected',
  COUNTED                          : 'Counted',
  MISSING                          : 'Missing',
  SETS                             : 'Sets',
  BASED_ON_21_CARDS_PER_SET        : 'based on 21 cards per set',
  INSUFFICIENT_CARDS_WARNING        : 'Warning: The card count is less than expected',
  EXCESS_CARDS_WARNING              : 'Warning: The card count is more than expected',
  EXACT_COUNT_MATCH                 : 'Perfect! The card count matches exactly',
  EXCESS                            : 'Excess',
  REPRINT_HOLD_NOTICE               : 'This job will be placed on HOLD for REPRINT',
  REPRINT_HOLD_EXPLANATION          : 'When you submit this form, the job will be moved to the HOLD (reprint) reason',
  LAMINATOR_QA_CHECK                : 'Laminator QA Check',
  VALIDATING_QA_CHECK               : 'Validating QA Check',
  QUALITY_CONTROL_CHECKLIST         : 'Quality Control Checklist',
  CHECK_FRONT_BACK_REG              : 'Did you check Front Print / Rear Print Registration?',
  CHECK_CHIP_TO_IMPRESSION          : 'Did you check Print versus Chip Registration?',
  CHECK_LAMINATION_QUALITY          : 'Did you check lamination quality?',
  CHECK_NO_AIR_BUBBLES              : 'Did you check for no air bubbles?',
  CHECK_EDGE_ALIGNMENT              : 'Did you check edge alignment?',
  CHECK_SMOOTH_EDGES                : 'Did you check the cards are smooth with no rough edges?',
  CHECK_PUNCH_ALIGNMENT             : 'Did you check the punch is aligned correctly and does not interfere with the card\'s printed information?',
  ENTER_REMAINING_SETS              : 'Please enter how many Sets are missing and need to be Reprinted. (including Scrap, Setup and Pending on Collator screen.)',
  MISSING_SETS_WARNING              : '%0 Set(s) are missing, Reprint is necessary before moving to Laminator.',
  JOB_HOLD_WARNING                  : 'Submitting will put the Job on Hold for reprint',
  RFID_WORK_ORDER                   : 'RFID Work Order',
  RIGHT                             : 'Right',
  ROLE                              : 'Role',
  ROTATION                          : 'Rotation',
  RUN_DATE                          : 'Run Date',
  RUSH                              : 'Rush',
  SAVE                              : 'Save',
  SAVE_UNVERIFIED_ADDRESS           : 'Save Unverified Address',
  SAVE_UNVERIFIED_ADDRESS_CONFIRM   : 'Are you sure you want to save an unverified address?',
  SIDE_A                            : 'Front',
  SIDE_B                            : 'Back',
  SCANNER_SELECTION                 : 'Please select a scanner',
  SCAN_AND_LOAD                     : 'Scan and load',
  SCAN_CHIP_TYPE                    : 'Please select or scan chip type (required)',
  SCAN_ID_TITLE                     : 'Scan Card',
  SCAN_ID_INVALID_TITLE             : 'Invalid Scan Card',
  SCAN_ID_BODY                      : 'All jobs(pages) and accessories have been scanned. Please confirm by scanning your Employee ID card.',
  SCAN_ID_INVALID_BODY              : 'Please ensure to only scan your Employee ID card.',
  SCRAP_MAXIMUM                     : 'Cannot exceed the maximum 999',
  SCRAP_QUANTITY                    : 'Scrap Quantity',
  SCRAP_REPORT                      : 'Scrap Report',
  SCRAP_REQUIRED                    : 'Please enter scrap for this batch',
  SCRAP_REASON_CODE                 : 'Scrap Reason Code',
  SCRAP_REASON    : {
    LACK_PRESSURE         : 'Falta de Presion',
    DEEP_CUT              : 'Corte Profundo',
    DAMAGED_MATERIAL      : 'Material Dañado (Manejo)',
    STRIPED_MATERIAL      : 'Material Rayado (Almacen/PMG)',
    STAINED_MATERIAL      : 'Material Manchado (Manejo)',
    STAINED_MAT_WAREHOUSE : 'Material Manchado (Almacen/PMG)',
    JOB_DUPLICATE         : 'Job Duplicado',
    CURVED_MATERIAL       : 'Material Curvo',
    WRONG_DICE            : 'Dado Equivocado',
    DAMAGED               : 'Dado Dañado',
    WRONG_MATERIAL        : 'Material Equivocado',
    OTHER                 : 'Other'
  },
  SCRAP_REASON_HEADER               : 'Please select a reason for entering this scrap',
  SCRAP_TOTALS                      : 'Please enter the scrap totals (sheet qty) for Batch',
  SEAL_BATCH                        : 'Seal this batch',
  SEALED                            : 'Sealed',
  SEALED_BATCH                      : 'Sealed Batch',
  SEALED_PRINTING                   : 'Sealed Printing',
  SERVICE                           : 'Service',
  SEARCH                            : 'Search',
  SEARCH_ARCHIVE                    : 'Search in Archive',
  SEARCH_JOBS_ORDER                 : 'Search Jobs/Orders...',
  SEARCH_ORDERS                     : 'Search Orders...',
  SEARCH_PRINTER                    : 'Search Printer',
  SEARCH_SHIPMENTS                  : 'Search Shipments...',
  SELECT_ALL                        : 'Select All',
  SELECT_HOLD_REASON                : 'Select a Hold Reason',
  SELECT_HORIZON                    : 'Select Horizon',
  SELECT_LASER                      : 'Select Laser',
  SELECTED_JOBS                     : "Selected jobs",
  SELECTED_SETS                     : "Selected sets",
  SELECTED_PRINTER                  : 'Selected Printer',
  SELECT_REASON                     : 'Select Reason',
  SEND                              : 'Send',
  SEND_AS                           : 'Send as %0',
  SEND_AS_NEW                       : 'Upgrade Shipping to %0',
  SEND_TO_DFE                       : 'Send All to DFE',
  SEND_TO_DFE_CONFIRM               : 'Are you sure you want to send all %0 batches to the DFE? This process is irreversible.',
  SEND_TO_DFE_NONE                  : 'There are currently no %0 batches available to send to the DFE.',
  SEND_REPRINTS_TO_DFE              : 'Send All Reprints to DFE',
  SERVER_ERROR                      : 'Unable to access the server. Please contact the system admin.',
  SERVICE_TYPE                      : 'Service Type',
  SERVICE_TYPE_ADJUSTMENT_HEADER    : 'Shipment Service Type Adjustment',
  SERVICE_TYPE_ADJUSTMENT_WARNING   : 'This shipment will not reach the customer in time. Are you sure you want to send it as "%0"? Otherwise, select a different method below.',
  SERVICEOPTIONSCHARGES             : 'Service Options Charges',
  SET_PASSWORD                      : 'Set Password',
  SETUP_SCRAP                       : 'Setup Scrap',
  SETTINGS                          : 'Settings',
  SHEET                             : 'Sheet',
  SHEET_QTY                         : 'Sheet Qty',
  SHEET_QTY_WARNING                 : "Warning: Total sheet quantity %0 exceeds the laminator's maximum limit of 120 sets. Please confirm this is correct before proceeding.",
  SHEET_CUT                         : 'Sheet Cut',
  SHEET_COUNT                       : 'Sheet Count',
  SHEET_COUNT_BIN                   : 'Please move job %0 to ',
  SHEET_COUNT_BODY                  : 'Please count the physical pages on hand from this job and enter the number to validate.',
  SHEET_COUNT_SUCCESS               : 'Thank you. Please move job to correct shipping bin.',
  SHEET_COUNT_ERROR                 : 'Number of Pages is incorrect. Please count and enter Number again.',
  SHEET_COUNT_ERROR2                : 'Thanks for counting again. Qty of sheet is still wrong, please click on "Incorrect Qty" to put the job On Hold.',
  SHEET_COUNT_JOB_INCOMPLETE        : 'Please enter the number of pages missing.',
  SHEET_INCORRECT_QTY               : 'Incorrect Sheet Quantity',
  SHEET_INCORRECT_QTY_EXTRA         : '<div>%0 Sheets are missing and need to be reprinted.</div><div>Please fill out a Reprint form and place job on Reprint rack.</div>',
  SHEET_INCORRECT_QTY_MISSING       : '<div>Job has %0 additional Sheets.</div><div>Please take Job to Press Coordinator for further review.</div>',
  SHEETS_PER_PACK                   : 'Sheets Per Pack',
  SHEETS                            : 'Sheets',
  INCOMPLETE_JOB                    : 'Incomplete Qty',
  VALIDATE                          : 'Validate',
  VALIDATING                        : 'Validating',
  VALIDATOR                         : 'Validator',
  VALIDATED                         : 'Validated',
  VALIDATION                        : 'Validation',
  ENTER_MISSING_SHEETS              : 'Enter Missing Sheets',
  SHIFT_1                           : 'Shift 1',
  SHIFT_2                           : 'Shift 2',
  SHIFT_3                           : 'Shift 3',
  SHIFTS_PLAN                       : 'Shifts Plan',
  SHIP_TO                           : 'Ship to',
  SHIP_WITH_MAILER                  : 'Less than 26 Sheets, use Mailer to ship',
  SHIPMENT                          : 'Shipment',
  SHIPMENT_ADDRESS_UPDATE_ERROR     : 'Could not update shipping address',
  SHIPMENT_ADDRESS_UPDATE_ERROR_INFO: 'Sorry, something went wrong when attempting to update the customer\'s shipping address',
  SHIPMENT_ADDRESS_UPDATED          : 'Updated shipping address',
  SHIPMENT_ADDRESS_UPDATED_INFO     : 'The customer\'s shipping address has been updated successfully!',
  SHIPMENT_CHARGES                  : 'Shipment Charges',
  SHIPMENT_CREATED                  : 'New Shipment Created',
  SHIPMENT_CREATED_INFO             : 'Shipment for Order "%0" has been created!',
  SHIPMENT_CREATE_ERROR_INFO        : 'Sorry, something went wrong when trying to create a shipment for Order %0',
  SHIPMENT_DELETED                  : 'Shipment Deleted',
  SHIPMENT_DELETED_INFO             : 'Shipment "%0" has been deleted!',
  SHIPMENT_DETAILS                  : 'Shipment Details',
  SHIPMENT_ID                       : 'Shipment ID',
  SHIPMENT_LABEL_ERROR              : 'Shipment Label Error',
  SHIPMENT_LABEL_ERROR_INFO         : 'Could not generate a shipping label for Order "%0". Please check the address and phone number of the shipment.',
  SHIPMENT_NOT_FOUND                : 'Oops! Shipment "%0" was not found.',
  SHIPMENT_NOW_READY                : 'Shipment is Ready',
  SHIPMENT_NOW_READY2               : 'All lines for Order',
  SHIPMENT_NOW_READY3               : 'are now ready for shipping!',
  SHIPMENT_NOW_READY4               : 'Please be sure to move the %0 line(s) (including this one) from Bin',
  SHIPMENT_NOW_READY4_ALT           : 'Please be sure to move the %0 line(s) (including this one) to the Packing Station.',
  SHIPMENT_NOW_READY5               : 'to the Packing Station.',
  SHIPMENT_PRICE_UPDATED            : 'Shipment Price Updated',
  SHIPMENT_READY_PROMPT             : 'Is the shipment for Order %0 ready to be sent to the Packing Station?',
  SHIPMENT_SERVICE_ADJUSTMENT       : 'The shipment method has been changed from "%0" to "%1".',
  SHIPMENT_SERVICE_ADJUSTMENT_AUTO  : 'The shipment method has been automatically changed from "%0" to "%1" in order to meet the promised delivery date.',
  SHIPMENT_TYPE                     : 'Shipment Type',
  SHIPMENT_UPDATED                  : 'Shipment Updated',
  SHIPMENT_UPDATED_INFO             : 'Shipment "%0" has been updated.',
  SHIPMENT_UPDATED_ERROR            : 'Shipment Update Error',
  SHIPMENT_UPDATED_ERROR_INFO1      : 'Sorry, something went wrong when attempting to update the shipment.',
  SHIPMENT_UPDATED_ERROR_INFO2      : 'Please contact your system administrator.',
  SHIPMENT_VOID_SUCCESS             : 'Shipment Label Voided',
  SHIPMENT_VOID_SUCCESS_INFO        : 'Shipment label has been voided for Order %0. Please be sure to remove the old labels from all packages for this shipment.',
  SHIPMENT_WITH_ON_HOLD             : 'A line in this Shipment is still On Hold',
  SHIPMENT_ERROR_OUTSYNC            : 'Shipment is already shipped. Impreso page may be out of sync, please hard refresh the client.',
  SHIPMENTS                         : 'Shipments',
  SHIPMENTS_NOT_FOUND               : 'Oops! Could not load any shipments!',
  SHIPPED                           : 'Shipped',
  SHIPPED_DATE                      : 'Shipped Date',
  SHIPPED_ORDERS                    : 'Shipped Orders',
  SHIPPED_NEXT                      : 'Ready to ship',
  SHIPPING                          : 'Shipping',
  SHIPPING_ADDRESS_ERROR_TITLE      : 'Shipping Error',
  SHIPPING_ADDRESS_ERROR            : 'Please make sure address is correct and/or shipping speed has been correctly inputted.',
  SHIPPING_ASSIGNMENT               : 'Shipping Assignment',
  SHIPPING_CONFIGURATION            : 'Shipping Configuration',
  SHIPPING_LABEL                    : 'Shipping Label',
  SHIPPING_TYPE                     : 'Shipping Type',
  SHIPPING_STATE                    : 'Shipping State',
  SHIPPING_METHOD                   : 'Shipping Method',
  SHOW_ALL_PRINTERS                 : 'Show All Printers',
  SIDED_PRINT                       : 'Sided Print',
  SIDED                             : 'Sided',
  SIGNIN_DESCRIPTION                : 'Sign in to your account',
  SIGNUP                            : 'Sign up',
  SIGNUP_INFO                       : 'Register a new account for Impreso Sheets',
  SINGLE_LINE                       : 'Single Line',
  SINGLE_LINE_ORDER                 : 'Single Line Order',
  SINGLES_READY                     : 'Singles Ready',
  SIMPLEX                           : 'One Sided',
  SIZE                              : 'Size',
  SIZE_HW_DIE                       : 'Size (HxW) | Die',
  SKU                               : 'SKU',
  SMALL_IMAGE                       : 'Small Image',
  SMARTSLITTER                      : 'SmartSlitter',
  SPECIAL_HANDLING                  : 'Special Handling',
  SPECIAL_INK_REQUIRED              : 'Special Ink Required',
  STAGING                           : 'ILS / Staging',
  STAGING_STATUS                    : 'ILS / Staging Status',
  START                             : 'Start',
  STATE                             : 'State',
  STATION                           : 'Station',
  STATUS                            : 'Status',
  START_CUTTING                     : 'Start Cutting',
  START_PRINTING                     : 'Start Printing',
  STEPPED_FILE                      : 'Stepped File',
  STICKERS                          : 'Stickers',
  STOP_CUTTING                      : 'Stop Cutting',
  STORE                             : 'Store',
  SUBASSEMBLY                       : 'Subassembly',
  SUBASSEMBLY_PROMPT                : 'Please select up to 5 subassemblies and optionally specify the time range',
  SUBMIT                            : 'Submit',
  SUBMIT_AND_REFRESH                : 'Submit & Refresh',
  SUCCESS                           : 'Success',
  SUPER_BIN_CONFIRM_BODY            : 'Are you sure you want to move Order %0 from Bin %1 to a SuperBin?',
  SUPER_BIN_CONFIRM_TITLE           : 'Move To SuperBin',
  SUPER_BIN_SUCCESS_BODY            : 'Please move Order %0 to ',
  SUPERVISOR                        : 'Supervisor',
  SUSPEND                           : 'Suspend',
  SWITCHSYSTEMFAILURE               : 'Switch System Failure',
  SYSTEM                            : {
    NAME   : 'System',
    SETTING: {
      USER_MANAGEMENT: {
        USER_MANAGEMENT_TITLE: 'User Management',
        USER_MANAGEMENT_USER_DETAILS: 'User Details',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_HELP: 'Enter the email of the new user you want to add to the group',
        USER_MANAGEMENT_USER_GROUP_NEW_ROLE_HELP: 'Enter the role you want to add to the group',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_ADD: 'Add User',
        NO_GROUP_MEMBERSHIPS: 'is not a member of any groups',
        MEMBER_LIST: 'Member List',
        ROLE_LIST: 'Role List',
        ADD_USER_BY_EMAIL: 'Add User by Email',
        ADD_BY_ROLE: 'Add by Role',
        USER_GROUP_MANAGE: 'Manage User Groups',
        GROUP_MEMBERS: 'Group Members',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_REMOVE: 'Remove User',
        USER_MANAGEMENT_USER_GROUP_NEW_ROLE_REMOVE: 'Remove Role',
        NO_MEMBERS: 'No members in this group',
        VIEW_USER: 'View user details',
        USER_MANAGEMENT_USER_DETAILS_EMAIL: 'Email',
        ROLE_PLACEHOLDER: 'Enter Role',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_ADD_HELP: 'Add the new user to the group',
        USER_MANAGEMENT_USER_GROUP_NEW_ROLE_ADD_HELP: 'Add the new role to the group',
        USER_MANAGEMENT_USER_DELETE: 'Delete User',
        SELECTED: 'Current',
      },
      USER_GROUP: {
        USER_GROUP_TITLE: 'User Groups',
        USER_GROUP_LIST: 'User Group List',
        USER_GROUP_SUBHEADER: 'User groups are collections of users who share the same access permissions',
        USER_GROUP_MANAGE: 'Manage User Groups',
        USER: {
          CREATE: 'Create User',
          EDIT: 'Edit User',
          DELETE: 'Delete User',
          CREATE_SUCCESS: 'User created successfully.',
          EDIT_SUCCESS: 'User updated successfully.',
          DELETE_SUCCESS: 'User deleted successfully.',
          SELECT_USER: 'Select User',
          ADD_USER: 'Add User',
        }
      },
      PERMISSION_GROUP: {
        HORIZON_CONFIG: {
          DESCRIPTION: 'These user roles have permission to change the horizon config.',
          NAME: 'Horizon Config Permission Group'
        }
      },
      EMAIL_CHAIN: {
        EMAIL_SELECT     : 'Select an email chain group',
        EMAIL_SELECT_HELP: 'Create or delete an existing user from the user group',
        ADMIN_EMAIL      : {
          DESCRIPTION: "This email chain receives administrative verification emails.",
          NAME       : "Admin Email Chain"
        },
        STUCK_BATCH_EMAIL_GROUP: {
          DESCRIPTION: "This email chain receives alerts about batches that are stuck in the system.",
          NAME       : "Stuck Batch Email Chain"
        },
        DIE_TRESHOLD_EMAIL: {
          DESCRIPTION: "This email chain receives notifications about die pressures exceeding the defined threshold.",
          NAME       : "Die Threshold Email Chain"
        },
        AMAZON_DF_EOD_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives Amazon DF End-of-Day (EOD) reports.",
          NAME       : "Amazon DF Email Chain"
        },
        EOD_SUCCESS_EMAIL: {
          DESCRIPTION: "This email chain receives successful End-of-Day (EOD) processing reports.",
          NAME       : "End-of-Day Success Email Chain"
        },
        EOD_STAGING_FAILURE_EMAIL: {
          DESCRIPTION: "This email chain receives alerts when the staging process fails during End-of-Day (EOD) processing.",
          NAME       : "End-of-Day Staging Failure Email Chain"
        },
        EOD_FAILURE_EMAIL: {
          DESCRIPTION: "This email chain receives notifications about failed End-of-Day (EOD) processes.",
          NAME       : "End-of-Day Failure Email Chain"
        },
        LATE_ORDERS_EMAIL: {
          DESCRIPTION: "This email chain receives reports on orders that are delayed or past due.",
          NAME       : "Late Orders Email Chain"
        },
        INTOUCH_REPORT_EMAIL: {
          DESCRIPTION: "This email chain receives daily End-of-Day (EOD) completion reports for Intouch orders.",
          NAME       : "Intouch Report Email Chain"
        },
        ORDER_CANCEL_EMAIL_GROUP: {
          DESCRIPTION: "This email chain receives notifications about order cancellations.",
          NAME       : "Order Cancellation Email Chain"
        },
        ORDER_IMPORT_FAIL_EMAIL_GROUP: {
          DESCRIPTION: "This email chain receives alerts when order import processes fail.",
          NAME       : "Order Import Failure Email Chain"
        },
        IMPOSER_TRIGGER_FAILURE_EMAIL_GROUP: {
          DESCRIPTION: "This email chain receives notifications about failures in the Imposer trigger process.",
          NAME       : "Imposer Trigger Failure Email Chain"
        },
        THRESHOLD_EMAILS: {
          DESCRIPTION: "This email chain receives notifications related to scanners that are inactive.",
          NAME       : "Threshold Emails Chain"
        },
        MISSING_PRESS_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives alerts about jobs missing from the press or stale printed jobs.",
          NAME       : "Missing Press/Stale Job Alerts Email Chain"
        },
        CUSTOMER_SERVICE_REPORT_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives reports for customer service.",
          NAME       : "Customer Service Report Email Chain"
        },
        KP_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives Key Performance Indicator (KPI) reports related to DPO Hold orders.",
          NAME       : "KPI Email Chain"
        },
        HOLD_ORDER_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives reports for jobs that are on hold or pending printing.",
          NAME       : "Hold Order Email Chain"
        },
        NOTIFICATION_EMAIL_RECEIVERS: {
          DESCRIPTION: "This email chain receives alerts regarding Lambda system errors.",
          NAME       : "Notification Email Receivers Chain"
        },
        SWITCH_SYSTEM_FAILURE_EMAIL: {
          DESCRIPTION: "This email chain receives alerts about failed Switch System jobs.",
          NAME       : "Switch System Failure Email Chain"
        },
        WEEKLY_EOD_REPORT: {
          DESCRIPTION: "This email chain receives weekly End-of-Day (EOD) reports.",
          NAME       : "Weekly End-of-Day Report Chain"
        },
        MONTHLY_DROPSHIP_CONSUMPTION_REPORT: {
          DESCRIPTION: "This email chain receives monthly reports on dropship consumption.",
          NAME       : "Monthly Dropship Consumption Report Chain"
        },
        WEEKLY_DROPSHIP_CONSUMPTION_REPORT: {
          DESCRIPTION: "This email chain receives weekly reports on dropship consumption.",
          NAME       : "Weekly Dropship Consumption Report Chain"
        },
        PREPRESS_EMAIL_GROUP: {
          DESCRIPTION: "This email chain receives alerts about prepress jobs that are piling up.",
          NAME       : "Prepress Job Alert Email Chain"
        },
        OA_WARNING_EMAIL: {
          DESCRIPTION: "This email chain receives warnings about large customer orders placed in the OA system.",
          NAME       : "OA Large Order Warning Email Chain"
        },
        SHIPMENTS_PACKAGE_REPORT: {
          DESCRIPTION: "This email chain receives reports about completed shipment packages.",
          NAME       : "Shipments Package Report Chain"
        },
        SHIPPING_CHARGES: {
          DESCRIPTION: "This user group has access to view shipment charges on the order details page.",
          NAME       : "Shipping Charges User Group"
        },
        RFID_HOTEL_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives reports about completed shipment packages.",
          NAME       : "RFID Hotel Email Chain"
        },
        RFID_IDCBAND_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives reports about completed shipment packages.",
          NAME       : "RFID IDCBand Email Chain"
        },
        CS_ADMINS: {
          DESCRIPTION: "Customer Service Admins, can change customer due date and delivery dates",
          NAME       : "Customer Service Admins"
        },
        CUT_MACHINE_CHANGE_EMAIL_LIST: {
          DESCRIPTION: "This email chain receives alerts about changes to cut machine assignments.",
          NAME       : "Cut Machine Change Email Chain"
        },
        END_OF_MONTH_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre el fin del mes.",
          NAME       : "Cadena de Correos de Fin de Mes"
        }
      },
      SHIPMENT_ALLOW_MP_UPGRADE: {
        DESCRIPTION: 'Allow the system to automatically upgrade the delivery method for a MarketPlace / Channel Advisor shipment (when applicable)',
        NAME       : 'Enable MarketPlace Shipping Speed Upgrade',
        'AMAZON' : {
          NAME: 'Amazon',
          DESCRIPTION: 'Amazon'
        },
        'GOOGLE' : {
          NAME: 'Google',
          DESCRIPTION: 'Google'
        },
        'NEWEGGB' : {
          NAME: 'NewEgg Business',
          DESCRIPTION: 'NewEgg Business'
        },
        'NEWEGGC' : {
          NAME: 'NewEgg Consumer',
          DESCRIPTION: 'NewEgg Consumer'
        },
        'WALMART' : {
          NAME: 'Walmart',
          DESCRIPTION: 'Walmart'
        },
        'OFFICEDEPOT' : {
          NAME: 'Office Depot',
          DESCRIPTION: 'Office Depot'
        },
        'MICHAELS' : {
          NAME: 'Michaels',
          DESCRIPTION: 'Michaels'
        },
        'STAPLES' : {
          NAME: 'Staples',
          DESCRIPTION: 'Staples Inc'
        },
        'QUILL' : {
          NAME: 'Quill',
          DESCRIPTION: 'Quill'
        },
        'TIKTOK' : {
          NAME: 'TikTok',
          DESCRIPTION: 'TikTok'
        },
        'ORIENTALTRADING' : {
          NAME: 'Oriental Trading Marketplace',
          DESCRIPTION: 'Oriental Trading Marketplace'
        },
        'TARGETPLUS' : {
          NAME: 'Target Plus',
          DESCRIPTION: 'Target Plus'
        },
      },
      ENABLE_SHIPPING: {
        DESCRIPTION: 'Toggle the availability of various UPS shipping service types',
        NAME       : 'Enable Shipping Methods',
        'M4'       : {
          DESCRIPTION: 'Enable UPS Mail Innovations shipping',
          NAME       : 'UPS Mail Innovations'
        },
        '1DA': {
          DESCRIPTION: 'Enable UPS Next Day Air shipping',
          NAME       : 'UPS Next Day Air'
        },
        '1DAS': {
          DESCRIPTION: 'Enable UPS Next Day Air (Saturday Delivery) shipping',
          NAME       : 'UPS Next Day Air (Saturday Delivery)'
        },
        '1DM': {
          DESCRIPTION: 'Enable UPS Next Day Air Early shipping',
          NAME       : 'UPS Next Day Air Early'
        },
        '1DMS': {
          DESCRIPTION: 'Enable UPS Next Day Air Early (Saturday Delivery) shipping',
          NAME       : 'UPS Next Day Air Early (Saturday Delivery)'
        },
        '1DP': {
          DESCRIPTION: 'Enable UPS Next Day Air Saver shipping',
          NAME       : 'UPS Next Day Air Saver'
        },
        '2DA': {
          DESCRIPTION: 'Enable UPS 2nd Day Air shipping',
          NAME       : 'UPS 2nd Day Air'
        },
        '2DAS': {
          DESCRIPTION: 'Enable UPS 2nd Day Air (Saturday) shipping',
          NAME       : 'UPS 2nd Day Air (Saturday)'
        },
        '2DM': {
          DESCRIPTION: 'Enable UPS 2nd Day Air A.M. shipping',
          NAME       : 'UPS 2nd Day Air A.M.'
        },
        '3DS': {
          DESCRIPTION: 'Enable UPS 3 Day Select shipping',
          NAME       : 'UPS 3 Day Select'
        },
        'GND': {
          DESCRIPTION: 'Enable UPS Ground shipping',
          NAME       : 'UPS Ground'
        },
        '01': {
          DESCRIPTION: 'Enable UPS Worldwide Express shipping',
          NAME       : 'UPS Worldwide Express'
        },
        '03': {
          DESCRIPTION: 'Enable UPS Standard shipping',
          NAME       : 'UPS Standard'
        },
        '05': {
          DESCRIPTION: 'Enable UPS Worldwide Expedited shipping',
          NAME       : 'UPS Worldwide Expedited'
        },
        '21': {
          DESCRIPTION: 'Enable UPS Worldwide Express Plus shipping',
          NAME       : 'UPS Worldwide Express Plus'
        },
        '28': {
          DESCRIPTION: 'Enable UPS Worldwide Saver shipping',
          NAME       : 'UPS Worldwide Saver'
        },
        '29': {
          DESCRIPTION: 'Enable UPS Worldwide Express Freight shipping',
          NAME       : 'UPS Worldwide Express Freight'
        },
        // FedEx
        'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS': {
          DESCRIPTION: 'Enable FedEx International Priority® Express',
          NAME: 'FedEx International Priority® Express'
        },
        'INTERNATIONAL_FIRST': {
          DESCRIPTION: 'Enable FedEx International First®',
          NAME: 'FedEx International First®'
        },
        'FEDEX_INTERNATIONAL_PRIORITY': {
          DESCRIPTION: 'Enable FedEx International Priority®',
          NAME: 'FedEx International Priority®'
        },
        'INTERNATIONAL_ECONOMY': {
          DESCRIPTION: 'Enable FedEx International Economy®',
          NAME: 'FedEx International Economy®'
        },
        'FEDEX_GROUND': {
          DESCRIPTION: 'Enable FedEx Ground',
          NAME: 'FedEx Ground'
        },
        'FEDEX_CARGO_INTERNATIONAL_PREMIUM': {
          DESCRIPTION: 'Enable FedEx International Premium®',
          NAME: 'FedEx International Premium®'
        },
        'FIRST_OVERNIGHT': {
          DESCRIPTION: 'Enable FedEx First Overnight®',
          NAME: 'FedEx First Overnight®'
        },
        'FEDEX_FIRST_FREIGHT': {
          DESCRIPTION: 'Enable FedEx First Overnight® Freight',
          NAME: 'FedEx First Overnight® Freight'
        },
        'FEDEX_1_DAY_FREIGHT': {
          DESCRIPTION: 'Enable FedEx 1Day® Freight  (Hawaii service is to and from the island of Oahu only)',
          NAME: 'FedEx 1Day® Freight  (Hawaii service is to and from the island of Oahu only)'
        },
        'FEDEX_2_DAY_FREIGHT': {
          DESCRIPTION: 'Enable FedEx 2Day® Freight (Hawaii service is to and from the island of Oahu only)',
          NAME: 'FedEx 2Day® Freight (Hawaii service is to and from the island of Oahu only)'
        },
        'FEDEX_3_DAY_FREIGHT': {
          DESCRIPTION: 'Enable FedEx 3Day® Freight (Except Alaska and Hawaii)',
          NAME: 'FedEx 3Day® Freight (Except Alaska and Hawaii)'
        },
        'INTERNATIONAL_PRIORITY_FREIGHT': {
          DESCRIPTION: 'Enable FedEx International Priority® Freight',
          NAME: 'FedEx International Priority® Freight'
        },
        'INTERNATIONAL_ECONOMY_FREIGHT': {
          DESCRIPTION: 'Enable FedEx International Economy® Freight',
          NAME: 'FedEx International Economy® Freight'
        },
        'FEDEX_CARGO_AIRPORT_TO_AIRPORT': {
          DESCRIPTION: 'Enable FedEx International Express Freight® and FedEx International Airport-to-AirportSM',
          NAME: 'FedEx International Express Freight® and FedEx International Airport-to-AirportSM'
        },
        'INTERNATIONAL_PRIORITY_DISTRIBUTION': {
          DESCRIPTION: 'Enable FedEx International Priority DirectDistribution®',
          NAME: 'FedEx International Priority DirectDistribution®'
        },
        'FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT': {
          DESCRIPTION: 'Enable FedEx International Priority DirectDistribution® Freight',
          NAME: 'FedEx International Priority DirectDistribution® Freight'
        },
        'INTL_GROUND_DISTRIBUTION': {
          DESCRIPTION: 'Enable International Ground® Distribution (IGD)',
          NAME: 'International Ground® Distribution (IGD)'
        },
        'GROUND_HOME_DELIVERY': {
          DESCRIPTION: 'Enable FedEx Home Delivery',
          NAME: 'FedEx Home Delivery'
        },
        'SMART_POST': {
          DESCRIPTION: 'Enable FedEx SmartPost',
          NAME: 'FedEx SmartPost'
        },
        'PRIORITY_OVERNIGHT': {
          DESCRIPTION: 'Enable FedEx Priority Overnight®',
          NAME: 'FedEx Priority Overnight®'
        },
        'STANDARD_OVERNIGHT': {
          DESCRIPTION: 'Enable FedEx Standard Overnight',
          NAME: 'FedEx Standard Overnight® (Hawaii outbound only)'
        },
        'FEDEX_2_DAY': {
          DESCRIPTION: 'Enable FedEx 2Day® (Except Intra-Hawaii)',
          NAME: 'FedEx 2Day® (Except Intra-Hawaii)'
        },
        'FEDEX_2_DAY_AM': {
          DESCRIPTION: 'Enable FedEx 2Day® AM (Hawaii outbound only)',
          NAME: 'FedEx 2Day® AM (Hawaii outbound only)'
        },
        'FEDEX_EXPRESS_SAVER': {
          DESCRIPTION: 'Enable FedEx Express Saver® (Except Alaska and Hawaii)',
          NAME: 'FedEx Express Saver® (Except Alaska and Hawaii)'
        },
        'SAME_DAY': {
          DESCRIPTION: 'Enable FedEx SameDay®',
          NAME: 'FedEx SameDay®'
        },
        'SAME_DAY_CITY': {
          DESCRIPTION: 'Enable FedEx SameDay® City (Selected U.S. Metro Areas)',
          NAME: 'FedEx SameDay® City (Selected U.S. Metro Areas)'
        },
        'FIRST_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Enable FedEx First Overnight® (Saturday)',
          NAME       : 'FedEx First Overnight® (Saturday)'
        },
        'PRIORITY_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Enable FedEx Priority Overnight® (Saturday)',
          NAME       : 'FedEx Priority Overnight® (Saturday)'
        },
        'STANDARD_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Enable FedEx Standard Overnight (Saturday)',
          NAME       : 'FedEx Standard Overnight (Saturday)'
        },
        'FEDEX_2_DAY_SATURDAY': {
          DESCRIPTION: 'Enable FedEx 2Day® (Saturday)',
          NAME       : 'FedEx 2Day® (Saturday)'
        },
        'FEDEX_2_DAY_AM_SATURDAY': {
          DESCRIPTION: 'Enable FedEx 2Day® AM (Saturday - Hawaii outbound only)',
          NAME       : 'FedEx 2Day® AM (Saturday - Hawaii outbound only)'
        }
      },
      NEXT_BUSINESS_DAY: {
        DESCRIPTION: 'Set the next business day for Sheets shipments to go out',
        NAME       : 'Next Business Day (Sheets)',
      },
      NEXT_BUSINESS_DAY_OA: {
        DESCRIPTION: 'Set the next business day for Online Aisle shipments to go out',
        NAME       : 'Next Business Day (Online Aisle)',
      },
      NEXT_BUSINESS_DAY_RFID: {
        DESCRIPTION: 'Set the next business day for RFID shipments to go out',
        NAME       : 'Next Business Day (RFID)',
      },
      SHIPMENT_ALLOW_DOWNGRADE: {
        DESCRIPTION: 'Allow the system to automatically downgrade the delivery method for a shipment (when applicable)',
        NAME       : 'Allow Shipment Speed Downgrade'
      },
      SHIPMENT_ALLOW_MI_DOWNGRADE: {
        DESCRIPTION: 'When activated, any incoming orders with free shipping or flat rate and weighing less than 0.8125 lbs will be automatically updated to the Mail Innovation Service type.',
        NAME       : 'Allow Mail Innovation Shipment Speed Downgrade'
      },
      PRINTING_PRINT_DIELINE_SHEET: {
        DESCRIPTION: 'Allow the system to Print the Die Line Sheets',
        NAME       : 'Print Die Line Sheets'
      },
      LASER_SHEET_LIMIT: {
        DESCRIPTION: 'Set the system limit of sheets for Jobs to cut on Laser',
        NAME       : 'Limit of Sheets for Laser'
      },
      ENABLE_EOD: {
        DESCRIPTION: 'Allow EOD to be processed.',
        NAME       : 'Allow EOD'
      },
      ENABLE_OA_EOD: {
        DESCRIPTION: 'Allow OA EOD to be processed.',
        NAME       : 'Allow OA EOD'
      },
      ENABLE_RFID_EOD: {
        DESCRIPTION: 'Allow RFID EOD to be processed.',
        NAME       : 'Allow RFID EOD'
      },
      ENABLE_SHEET_EOD: {
        DESCRIPTION: 'Allow Sheets EOD to be processed.',
        NAME       : 'Allow Sheets EOD'
      },
      DARK_BORDER_SCALE: {
        DESCRIPTION: 'Update threshold for cutting dark artwork on Horizon',
        NAME       : 'Dark Layer Threshold'
      },
      LOCATION_SCANNERS: {
        DESCRIPTION: 'If there are no results within the time threshold, then the scanner is considered inactive.',
        NAME: 'Time Threshold (Hours)'
      },
      ENABLE_CUTTING : {
        DESCRIPTION: 'Allow the system to process cutting from Job Page.',
        NAME       : 'Allow Job Cutting'
      }
    },
    SETTINGS: 'System Settings'
  },
  SYSTEMS                     : 'Systems',
  TAGS                        : 'Tags',
  TAG_HOLE_PUNCHER            : 'Tag Hole Puncher',
  TARGET_PACKING_INSTRUCTIONS : 'Target+ Order - Please pack order without Packing List. ',
  TARGETPLUS_ORDERS           : 'Target+ Orders',
  TARIFF_CODE                 : 'Tariff Code',
  TEAM                        : 'Team',
  TEMPLATE                    : 'Template',
  TEMPLATES                   : 'Templates',
  TEMPLATE_CLONE              : 'Clone Template',
  TEMPLATE_CLONE_INFO         : 'Enter a name for the template clone of the "%0" template below',
  TEMPLATE_CREATE_HELP        : 'Or, create a new template by entering a template name',
  TEMPLATE_MANAGER            : 'Template Manager',
  TEMPLATE_MAPPING            : 'Template Mapping',
  TEMPLATE_MAPPING_WARNING    : 'This product still needs to be mapped to a template.',
  TEMPLATE_NAME               : 'Template Name',
  TEMPLATE_NESTED_CONFIG      : 'Template Nested Configuration',
  TEMPLATE_NEW                : 'New Template',
  TEMPLATE_NO_OVERLAY         : 'This template does not have an overlay file.',
  TEMPLATE_OVERLAYS           : 'Template Overlays',
  TEMPLATE_OVERLAYS_UPDATED   : 'Overlay files have been updated for the following template(s):',
  TEMPLATE_RENAME             : 'Template Rename',
  TEMPLATE_RENAME_INFO        : 'Enter a new name for the "%0" template below',
  TEMPLATE_SELECT             : 'Select a Template',
  TEMPLATE_SELECT_HELP        : 'Modify, clone from, or delete an existing template',
  TEMPLATES_LOST_OVERLAYS     : 'The following template(s) no longer have an overlay file:',
  TEMPLATES_NOT_FOUND         : 'Oops! Could not load any templates!',
  THANK_YOU_CARD              : 'Thank You Card',
  THIS_MONTH                  : 'This Month',
  THIS_WEEK                   : 'This Week',
  THUMBNAIL                   : 'Thumbnail',
  TICKETS                     : 'Tickets',
  TICKETS_CHECK               : 'Please verify that the Tickets are in sequential order. (1, 2, 3, 4, …)',
  TIMING                      : 'Timing',
  TRACKING_NUMBER             : 'Tracking Number',
  TRACKING_NUMBER_UPDATED     : 'Tracking Number Updated',
  TO_ONLINE_AISLE             : 'To Online Aisle',
  TO_ORDER                    : 'To Order',
  TO_SHEETS                   : 'To WePrint Sheets',
  TO_RFID                     : 'To RFID',
  TO_SHIPMENT                 : 'To Shipment',
  TODAY                       : 'Today',
  TOGGLE_LASER                : 'Toggle Laser',
  TOMORROW                    : 'Tomorrow',
  TOP                         : 'Top',
  TOOLS                       : 'Tools',
  TOTAL                       : 'Total',
  TOTALCHARGE                 : 'Total Charge',
  TOTAL_ITEM_COUNT            : 'Total Item Count',
  TOTAL_JOB_COUNT             : 'Total Job Count',
  TOTAL_QTY                   : 'Total Qty',
  TOTAL_SHEETS                : 'Total Sheets',
  TOTAL_SHIPMENTS             : 'Total Shipments',
  TOTAL_SHIPMENT_PRICE        : 'Total Shipment Price',
  TOTAL_WEIGHT                : 'Total Weight',
  TRANSPORTATIONCHARGES       : 'Transportation Charges',
  TRIGGERED_BY                : 'Triggered By',
  TWOSIDED                    : 'Two Sided',
  TWOSIDEDFLIPX               : 'Two Sided',
  TYPE                        : 'Type',
  UPDATE                      : 'Update',
  UPDATE_LTL_TRACKING_NUMBER  : 'Update LTL Tracking Number',
  UPDATE_SHIPMENT_PRICE       : 'Update Shipment Price',
  UPDATED                     : 'Updated',
  UPLOAD                      : 'Upload',
  UPLOAD_FRONT                : 'Upload Front',
  UPLOAD_BACK                 : 'Upload Back',
  UPLOAD_FILE                 : 'Upload File',
  UPLOAD_ARTWORK              : 'Upload Artwork: %0',
  UNCANCEL_ORDER              : 'Un-Cancel Order',  
  UNCOATED                    : 'Uncoated',
  UNDO_QA                     : 'Undo QA',
  UNDO_QA_CONFIRM             : 'Please enter a undo reason (required): ',
  UNITS                       : 'Units',
  UNLOCK_BATCH                : 'Unlock Batch',
  UNMAPPED_PRODUCTS           : 'Unmapped Products',
  UNSAVED_CHANGES             : 'Unsaved Changes',
  UNSAVED_CHANGES_WARNING     : 'You still have unsaved changes. Do you want to leave this page and discard your changes or stay on this page? Click OK to continue or Cancel to stay on the current page.',
  USAGE_STATUS                : 'Usage Status',
  USE_HOLD_BINS               : 'Assign Hold Bin',
  USE_HOLD_DESC               : 'This will assign a BIN to the current Job/Order',
  USER                        : 'User',
  USER_ALREADY_EXISTS         : 'User "%0" already exists!',
  USER_CREATED                : 'User "%0" has been created!',
  USER_DELETED                : 'User "%0" has been deleted!',
  USER_DETAILS                : 'User Details',
  USER_LIST                   : 'User List',
  USER_SELECT                 : 'Select a User',
  USER_SELECT_HELP            : 'Create or delete an existing user',
  USER_UPDATED                : 'User "%0" has been updated!',
  USER_VERIFIED               : 'User Verified',
  USERS                       : 'Users',
  USERNAME                    : 'Username',
  USERNAME_REQUIRED           : 'Username is required.',
  VALUE                       : 'Value',
  VERIFICATION                : 'Verification',
  VERIFICATION_DESCRIPTION    : 'User Registration Verification',
  VERIFY_NEW_PASSWORD         : 'Verify New Password',
  VERIFY_NEW_PASSWORD_REQUIRED: 'Please re-enter your new password.',
  VERIFYING                   : 'Please wait while we verify the registered account...',
  VERSIONS                    : 'Versiones',
  VDP_VERSIONS                : 'VDP Versions',
  VIEW_ARTWORK                : 'View Artwork',
  VIEW_IMPOSED_FILE           : 'View Imposed File',
  VOID_SHIPMENT_LABEL         : 'Void Shipping Label',
  VOID_SHIPMENT               : 'Void Shipment',
  VOID_SHIPMENT_CONFIRM       : 'Please enter a void reason: ',
  WAITING                     : 'Waiting',
  WARNING                     : 'Warning!',
  WEIGHT                      : 'Weight',
  WHITE_LAYER                 : 'White Layer',
  WHITE_INK                   : 'White Ink',
  WHITE_INK_CONFIRMATION      : 'Job with White Underprint! Please check if white ink got applied correctly.',
  WIDTH                       : 'Width',
  WILL_BE                     : 'will be',
  MOVED                       : 'moved',
  TO                          : 'to',
  WORK_ORDER                  : 'Work Order',
  WORK_ORDER_PRINT            : 'Print Work Order',
  WORK_ORDER_PRINTED          : 'Work Order Printed',
  WORK_ORDER_PRINTED_MANUALLY : 'Work Order Printed Manually',
  WORK_ORDER_PRINT_ERROR      : 'Work Order Printer Error',
  WORKING_HOURS               : 'Working Hours',
  WORKING_ROLES               : 'Working Roles',
  WORKING_SHIFTS              : 'Working Shifts',
  YELLOWBAG                   : {
    ADD                  : 'Add Yellow Bag',
    BAGS                 : 'Yellow Bags',
    CONTAINS             : 'Contains %0 order(s)',
    CURRENT_TOTAL        : 'Current Yellow Bag Total',
    DELETE               : 'Delete Yellow Bag',
    DELETE_CONFIRM       : 'Are you sure you want to delete this yellow bag? Its shipment label will be voided and all of its packages will need to be reassigned!',
    DETAILS              : 'Yellow Bag Details',
    MAIN_INFO1           : 'Add any UPS Mail Innovations yellow bags here.',
    MAIN_INFO2           : 'All UPS Mail Innovations orders must be assigned to a yellow bag prior to running an End Of Day process!',
    NO_OUTSTANDING       : 'There aren\'t any outstanding Mail Innovations orders.',
    UNASSIGNED_MID_ORDERS: 'Unassigned MID Orders'
  },
  YES: 'Yes',
  YESTERDAY: 'Yesterday',
  'KISS-CUT' : 'Kiss Cut',
  'DIE-CUT' : 'Die Cut',
  'DA270ENV25 Envelope A2' : 'DA270ENV25 Envelope A2',
  'DNBH64403 Bag & Lace' : 'DNBH64403 Bag & Lace',
  // 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)' : 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)'
  'DX2820008 - totalQty Strings (totalQty_25 packs of 25)' : 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  FORM_INVALID                     : 'Invalid Form',
  FORM_VALID                       : 'Valid Form',
  FRAME_COUNT                      : 'Frame Count',
  FREE                             : 'Free',
  FREE_SAMPLE                      : 'Free Sample',
  FROM                             : 'From',
  FULL_PRESSURE                    : 'Full Pressure',
  FUTURE_ORDERS                    : 'Future Orders',
  GEOMETRY                         : 'Geometry',
  CARRIER_CHANGE_NOT_POSSIBLE_CUSTOMER_ACCOUNT: 'Carrier change not possible - customer supplied account requires specific carrier billing',
};



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/i18n/lang_en.ts